"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2084],{

/***/ 49611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ getDarkLogoSrcForCurrentLang; },
/* harmony export */   "j": function() { return /* binding */ getLogoSrcForCurrentLang; }
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48680);

const getLogoSrcForCurrentLang = (lang)=>{
    let logoLang = lang;
    const secondaryLogoSameAsPrimary = "true" === "true";
    const primaryLanguage = "at";
    if (secondaryLogoSameAsPrimary && primaryLanguage && primaryLanguage !== lang) {
        logoLang = primaryLanguage;
    }
    switch(logoLang){
        case _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LANGUAGE.PL */ .Z.LANGUAGE.PL:
            return "/blocks/MainHeader/logoCLpl.svg";
        case _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LANGUAGE.RO */ .Z.LANGUAGE.RO:
            return "/blocks/MainHeader/logoCLro.svg";
        case _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LANGUAGE.AT */ .Z.LANGUAGE.AT:
            return "/blocks/MainHeader/logoCLat.svg";
        default:
            return "/blocks/MainHeader/logoCLen.svg";
    }
};
const getDarkLogoSrcForCurrentLang = (lang)=>{
    let logoLang = lang;
    const secondaryLogoSameAsPrimary = "true" === "true";
    const primaryLanguage = "at";
    if (secondaryLogoSameAsPrimary && primaryLanguage && primaryLanguage !== lang) {
        logoLang = primaryLanguage;
    }
    switch(logoLang){
        case _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LANGUAGE.PL */ .Z.LANGUAGE.PL:
            return "/blocks/MainHeader/logoCLplDark.svg";
        case _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LANGUAGE.RO */ .Z.LANGUAGE.RO:
            return "/blocks/MainHeader/logoCLroDark.svg";
        case _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LANGUAGE.AT */ .Z.LANGUAGE.AT:
            return "/blocks/MainHeader/logoCLatDark.svg";
        default:
            return "/blocks/MainHeader/logoCLenDark.svg";
    }
};


/***/ }),

/***/ 50505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BasicButton_BasicButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/BasicButton/BasicButton.tsx


const BasicButton = (param)=>{
    let { onClick , disabled , children , className , type ="button"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: type,
        className: "BasicButton ".concat(className ? className : ""),
        onClick: onClick,
        disabled: disabled,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "BasicButton__label",
            children: children
        })
    });
};
/* harmony default export */ var BasicButton_BasicButton = (BasicButton);

;// CONCATENATED MODULE: ./src/components/BasicButton/index.ts



/***/ }),

/***/ 68257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Icon_Icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Icon/Icons.ts
const ICONS = {
    BUBBLE: "M512 64c282.77 0 512 186.25 512 416 0 229.752-229.23 416-512 416-27.156 0-53.81-1.734-79.824-5.044-109.978 109.978-241.25 129.7-368.176 132.596v-26.916c68.536-33.578 128-94.74 128-164.636 0-9.754-0.758-19.33-2.164-28.696-115.796-76.264-189.836-192.754-189.836-323.304 0-229.75 229.23-416 512-416z",
    MENU: "M0 184.32v40.96h1024v-40.96zM0 491.52v40.96h1024v-40.96zM0 798.72v40.96h1024v-40.96z",
    FACEBOOK: "M608 192h160v-192h-160c-123.514 0-224 100.486-224 224v96h-128v192h128v512h192v-512h160l32-192h-192v-96c0-17.346 14.654-32 32-32z",
    TWITTER: "M1024 226.4c-37.6 16.8-78.2 28-120.6 33 43.4-26 76.6-67.2 92.4-116.2-40.6 24-85.6 41.6-133.4 51-38.4-40.8-93-66.2-153.4-66.2-116 0-210 94-210 210 0 16.4 1.8 32.4 5.4 47.8-174.6-8.8-329.4-92.4-433-219.6-18 31-28.4 67.2-28.4 105.6 0 72.8 37 137.2 93.4 174.8-34.4-1-66.8-10.6-95.2-26.2 0 0.8 0 1.8 0 2.6 0 101.8 72.4 186.8 168.6 206-17.6 4.8-36.2 7.4-55.4 7.4-13.6 0-26.6-1.4-39.6-3.8 26.8 83.4 104.4 144.2 196.2 146-72 56.4-162.4 90-261 90-17 0-33.6-1-50.2-3 93.2 59.8 203.6 94.4 322.2 94.4 386.4 0 597.8-320.2 597.8-597.8 0-9.2-0.2-18.2-0.6-27.2 41-29.4 76.6-66.4 104.8-108.6z",
    LINKEDIN: "M384 384h177.106v90.782h2.532c24.64-44.194 84.958-90.782 174.842-90.782 186.946 0 221.52 116.376 221.52 267.734v308.266h-184.61v-273.278c0-65.184-1.334-149.026-96.028-149.026-96.148 0-110.82 70.986-110.82 144.292v278.012h-184.542v-576z M64 384h192v576h-192v-576z M256 224c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
    YT: "M1013.8 307.2c0 0-10-70.6-40.8-101.6-39-40.8-82.6-41-102.6-43.4-143.2-10.4-358.2-10.4-358.2-10.4h-0.4c0 0-215 0-358.2 10.4-20 2.4-63.6 2.6-102.6 43.4-30.8 31-40.6 101.6-40.6 101.6s-10.2 82.8-10.2 165.8v77.6c0 82.8 10.2 165.8 10.2 165.8s10 70.6 40.6 101.6c39 40.8 90.2 39.4 113 43.8 82 7.8 348.2 10.2 348.2 10.2s215.2-0.4 358.4-10.6c20-2.4 63.6-2.6 102.6-43.4 30.8-31 40.8-101.6 40.8-101.6s10.2-82.8 10.2-165.8v-77.6c-0.2-82.8-10.4-165.8-10.4-165.8zM406.2 644.8v-287.8l276.6 144.4-276.6 143.4z",
    INSTAGRAM: "M512 92.8c137.6 0 153.6 0 208 3.2 51.2 3.2 76.8 9.6 96 16 22.4 9.6 41.6 19.2 57.6 38.4 19.2 19.2 28.8 35.2 38.4 57.6 6.4 19.2 16 44.8 16 96 3.2 54.4 3.2 70.4 3.2 208s0 153.6-3.2 208c-3.2 51.2-9.6 76.8-16 96-9.6 22.4-19.2 41.6-38.4 57.6-19.2 19.2-35.2 28.8-57.6 38.4-19.2 6.4-44.8 16-96 16-54.4 3.2-70.4 3.2-208 3.2s-153.6 0-208-3.2c-51.2-3.2-76.8-9.6-96-16-22.4-9.6-41.6-19.2-57.6-38.4-19.2-19.2-28.8-35.2-38.4-57.6-6.4-19.2-16-44.8-16-96-3.2-54.4-3.2-70.4-3.2-208s0-153.6 3.2-208c3.2-51.2 9.6-76.8 16-96 9.6-22.4 19.2-41.6 38.4-57.6 19.2-19.2 35.2-28.8 57.6-38.4 19.2-6.4 48-16 96-16 54.4-3.2 70.4-3.2 208-3.2v0zM512 0c-137.6 0-156.8 0-211.2 3.2s-92.8 9.6-124.8 22.4c-35.2 12.8-64 32-89.6 57.6-28.8 32-44.8 60.8-60.8 92.8-12.8 32-22.4 70.4-22.4 124.8-3.2 54.4-3.2 73.6-3.2 211.2s0 156.8 3.2 211.2c3.2 54.4 9.6 92.8 22.4 124.8 12.8 35.2 32 64 60.8 89.6 28.8 28.8 57.6 44.8 89.6 57.6s70.4 22.4 124.8 22.4c54.4 6.4 70.4 6.4 211.2 6.4s156.8 0 211.2-3.2c54.4-3.2 92.8-12.8 124.8-22.4 32-12.8 60.8-32 89.6-57.6s44.8-57.6 57.6-89.6c12.8-32 22.4-70.4 22.4-124.8 6.4-57.6 6.4-73.6 6.4-214.4s0-156.8-3.2-211.2c-3.2-54.4-12.8-92.8-22.4-124.8-12.8-35.2-28.8-64-57.6-89.6-28.8-28.8-57.6-44.8-89.6-57.6s-70.4-22.4-124.8-22.4c-57.6-6.4-76.8-6.4-214.4-6.4v0 0zM512 249.6c-144 0-262.4 118.4-262.4 262.4s118.4 262.4 262.4 262.4 262.4-118.4 262.4-262.4c0-144-118.4-262.4-262.4-262.4zM512 681.6c-92.8 0-169.6-76.8-169.6-169.6s76.8-169.6 169.6-169.6 169.6 76.8 169.6 169.6-76.8 169.6-169.6 169.6zM848 240c0 35.2-28.8 60.8-60.8 60.8s-60.8-28.8-60.8-60.8 28.8-60.8 60.8-60.8 60.8 25.6 60.8 60.8z",
    PERSON: "M576 706.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z",
    CLOSE: "M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z",
    HAT: "M762.846 734.731c-0.523 0.017-1.138 0.027-1.755 0.027-8.422 0-16.412-1.852-23.584-5.17l0.348 0.144-700.369-304.888c-22.251-9.889-37.487-31.796-37.487-57.261 0-0.076 0-0.153 0-0.229l-0 0.012c0.933-24.561 15.907-45.409 37.088-54.822l0.398-0.158 700.369-307.387c7.36-3.296 15.951-5.216 24.991-5.216s17.631 1.92 25.388 5.374l-0.397-0.158 699.744 307.387c22.128 9.834 37.316 31.55 37.486 56.832l0 0.022c0 0.065 0 0.141 0 0.218 0 25.466-15.236 47.373-37.089 57.103l-0.397 0.158-699.744 304.888c-7.224 3.161-15.643 5-24.491 5-0.176 0-0.352-0.001-0.527-0.002l0.027 0zM218.67 367.365l544.176 236.788 543.551-236.788-543.551-236.788-544.176 236.788zM762.846 1024c205.235-0.48 395.493-64.198 552.43-172.692l-3.256 2.129c16.682-11.389 27.49-30.313 27.49-51.762 0-0.033-0-0.066-0-0.099l0 0.005v-333.003c0-34.505-27.972-62.477-62.477-62.477s-62.477 27.972-62.477 62.477v0 299.265c-127.688 82.377-283.669 131.335-451.085 131.335s-323.396-48.958-454.406-133.338l3.321 2.003v-299.265c0-34.505-27.972-62.477-62.477-62.477s-62.477 27.972-62.477 62.477v0 333.003c-0 0.028-0 0.061-0 0.094 0 21.449 10.808 40.373 27.275 51.623l0.215 0.139c153.344 106.133 343.123 169.812 547.735 170.562l0.189 0.001zM1499.451 854.062c17.113-0.343 30.896-14.126 31.238-31.206l0.001-0.032v-458.582c-0.343-17.113-14.126-30.896-31.206-31.238l-0.032-0.001c-17.253 0-31.239 13.986-31.239 31.239v0 458.582c0 17.253 13.986 31.239 31.239 31.239v0zM1499.451 885.301c34.505 0 62.477-27.972 62.477-62.477v0-218.67c0-34.505-27.972-62.477-62.477-62.477s-62.477 27.972-62.477 62.477v0 218.67c0 34.505 27.972 62.477 62.477 62.477v0z",
    LABEL: "M546.355 1024l-546.355-546.355 477.645-477.645h545.523v546.355zM117.85 477.645l428.506 427.257 393.526-393.109v-428.506h-427.673zM374.786 560.93c-11.279-0.67-20.199-9.88-20.405-21.218l-0-0.020c0.166-5.495 2.354-10.449 5.841-14.17l-0.011 0.012 239.447-239.863c3.803-3.909 9.114-6.334 14.991-6.334 11.548 0 20.909 9.361 20.909 20.909 0 5.67-2.257 10.813-5.922 14.58l0.005-0.005-239.031 240.28c-3.69 3.826-8.851 6.212-14.569 6.246l-0.006 0zM481.809 668.786c-11.279-0.67-20.199-9.88-20.405-21.218l-0-0.020c0.166-5.495 2.354-10.449 5.841-14.17l-0.011 0.012 239.031-239.863c3.803-3.909 9.114-6.334 14.991-6.334 11.548 0 20.909 9.361 20.909 20.909 0 5.67-2.257 10.813-5.922 14.58l0.005-0.005-237.781 239.447c-3.69 3.826-8.851 6.212-14.569 6.246l-0.006 0zM794.964 169.070c-29.895 2.238-53.303 27.043-53.303 57.316 0 31.738 25.729 57.467 57.467 57.467 31.685 0 57.381-25.643 57.467-57.308l0-0.008c0.032-0.702 0.051-1.525 0.051-2.352 0-15.424-6.401-29.353-16.691-39.275l-0.017-0.016c-9.97-9.424-23.457-15.217-38.298-15.217-1.764 0-3.509 0.082-5.232 0.242l0.221-0.017z",
    CALENDAR: "M873.849 1024c-154.646 0-280.011-125.365-280.011-280.011s125.365-280.011 280.011-280.011c154.646 0 280.011 125.365 280.011 280.011v0 0c0 154.646-125.365 280.011-280.011 280.011v0zM873.849 509.52c-129.743 0-234.92 105.177-234.92 234.92s105.177 234.92 234.92 234.92c129.743 0 234.92-105.177 234.92-234.92v0c0-129.743-105.177-234.92-234.92-234.92v0zM828.759 906.314c-12.768-0.050-24.276-5.399-32.448-13.96l-0.017-0.018-74.85-77.555c-7.701-8.080-12.439-19.043-12.439-31.112 0-24.924 20.205-45.129 45.129-45.129 12.854 0 24.454 5.374 32.673 13.999l0.017 0.018 38.778 40.581 130.762-159.62c8.348-10.133 20.898-16.545 34.945-16.545 24.951 0 45.177 20.226 45.177 45.177 0 10.903-3.863 20.904-10.294 28.71l0.062-0.077-163.227 198.848c-7.988 9.808-19.886 16.167-33.283 16.681l-0.084 0.003zM798.098 240.331c-24.903 0-45.090-20.188-45.090-45.090v0-150.151c0-24.903 20.188-45.090 45.090-45.090s45.090 20.188 45.090 45.090v0 150.151c0 24.903-20.188 45.090-45.090 45.090v0zM225.451 240.331c-24.903 0-45.090-20.188-45.090-45.090v0-150.151c0-24.903 20.188-45.090 45.090-45.090s45.090 20.188 45.090 45.090v0 150.151c0 24.903-20.188 45.090-45.090 45.090v0zM968.088 386.424h-916.685c-12.451 0-22.545-10.094-22.545-22.545s10.094-22.545 22.545-22.545v0h916.685c12.451 0 22.545 10.094 22.545 22.545s-10.094 22.545-22.545 22.545v0zM256.113 476.604h-87.475v87.475h87.475v-86.122zM405.812 477.957h-85.672v87.475h85.672v-87.475zM556.865 477.957h-85.672v87.475h87.475v-87.475zM708.368 477.957h-85.672v87.475h87.475v-87.475zM256.113 618.638h-87.475v87.024h87.475v-87.024zM407.616 618.638h-87.475v87.024h85.672v-87.024zM558.668 618.638h-87.475v87.024h87.475v-87.024zM639.831 901.805h-594.741c-24.903 0-45.090-20.188-45.090-45.090v0-736.324c0-24.903 20.188-45.090 45.090-45.090v0h925.703c24.903 0 45.090 20.188 45.090 45.090v0 385.522h-90.181v-340.432h-835.523v646.144h549.65z",
    MARKER: "M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z",
    STAR: "M841.522 1024c-0.045 0-0.098 0-0.151 0-9.35 0-17.994-3.024-25.007-8.147l0.12 0.084-280.507-203.697-281.356 203.697c-6.881 5.012-15.502 8.019-24.826 8.019s-17.945-3.007-24.947-8.104l0.122 0.084c-10.799-7.793-17.747-20.343-17.747-34.515 0-4.651 0.748-9.127 2.131-13.314l-0.086 0.3 107.789-329.31-279.659-203.697c-10.687-7.802-17.551-20.287-17.551-34.374 0-23.437 19-42.437 42.437-42.437 0.053 0 0.107 0 0.16 0l-0.008-0h346.284l106.941-329.31c5.538-17.437 21.583-29.85 40.527-29.85s34.989 12.413 40.445 29.549l0.083 0.3 106.941 329.31h346.284c18.722 0.014 34.605 12.15 40.228 28.982l0.087 0.3c1.348 3.959 2.126 8.52 2.126 13.263 0 14.023-6.802 26.458-17.286 34.184l-0.117 0.082-280.507 203.697 107.365 329.31c1.297 3.888 2.045 8.364 2.045 13.014 0 14.172-6.947 26.722-17.622 34.429l-0.125 0.086c-6.821 4.987-15.359 8.001-24.599 8.063l-0.015 0zM535.977 717.606c0.045-0 0.098-0 0.151-0 9.35 0 17.994 3.024 25.007 8.147l-0.12-0.084 199.453 144.709-75.962-233.827c-1.348-3.959-2.126-8.52-2.126-13.263 0-14.023 6.802-26.458 17.286-34.184l0.117-0.082 199.453-145.134h-246.558c-0.619 0.032-1.345 0.051-2.074 0.051-18.753 0-34.665-12.164-40.276-29.032l-0.086-0.3-76.386-234.251-73.84 233.827c-5.71 17.132-21.593 29.267-40.313 29.281l-246.56 0 199.453 145.134c10.667 7.804 17.517 20.277 17.517 34.349 0 4.869-0.82 9.547-2.33 13.902l0.090-0.298-75.962 233.827 199.453-144.709c6.821-4.987 15.359-8.001 24.599-8.063l0.015-0z",
    RIGHT_ARROW: "M1536 0l512 512-512 512-109.714-109.714 329.143-329.143h-1755.429v-146.286h1755.429l-329.143-329.143z",
    DOWN_ARROW: "M962.878 274.654c-12.701-12.701-33.34-12.701-46.040 0l-404.837 405.631-405.631-405.631c-12.701-12.701-33.34-12.701-46.040 0s-12.701 33.34 0 46.040l427.857 427.857c6.35 6.35 14.288 9.526 23.020 9.526 7.938 0 16.67-3.175 23.020-9.526l427.857-427.857c13.495-12.701 13.495-33.34 0.794-46.040z",
    UP_ARROW: "M1013.768 701.83l-478.18-478.147c-6.832-6.839-14.692-10.264-23.583-10.264s-16.765 3.425-23.601 10.264l-478.14 478.147c-6.85 6.85-10.264 14.71-10.264 23.605 0 8.891 3.425 16.762 10.264 23.597l51.292 51.288c6.839 6.839 14.71 10.257 23.601 10.257s16.762-3.418 23.601-10.257l403.247-403.24 403.262 403.265c6.836 6.839 14.71 10.235 23.587 10.235 8.906 0 16.776-3.418 23.612-10.235l51.299-51.31c6.836-6.836 10.232-14.71 10.232-23.597 0.004-8.898-3.393-16.769-10.228-23.608z",
    NEXT: "M774.115 491.587l-483.056-483.056c-11.374-11.374-29.614-11.374-40.988 0s-11.374 29.614 0 40.988l462.455 462.455-462.455 462.455c-11.374 11.374-11.374 29.614 0 40.988 5.58 5.58 13.090 8.584 20.387 8.584s14.807-2.79 20.387-8.584l483.056-483.056c11.374-11.159 11.374-29.614 0.215-40.773z",
    BACK: "M311.568 511.973l462.455-462.455c11.374-11.374 11.374-29.614 0-40.988s-29.614-11.374-40.988 0l-483.056 483.056c-11.374 11.374-11.374 29.614 0 40.988l483.056 482.842c5.58 5.58 13.090 8.584 20.387 8.584s14.807-2.79 20.387-8.584c11.374-11.374 11.374-29.614 0-40.988l-462.24-462.455z",
    THUMBS_UP: "M193.455 1024c-0.539 0.025-1.172 0.039-1.807 0.039-19.014 0-35.1-12.536-40.444-29.794l-0.080-0.3-149.43-507.979c-1.075-3.55-1.693-7.629-1.693-11.853 0-19.155 12.723-35.339 30.179-40.561l0.3-0.077 253.989-75.35c3.524-1.004 7.57-1.582 11.752-1.582 7.46 0 14.49 1.838 20.663 5.085l-0.243-0.117c9.79 5.445 17.078 14.387 20.243 25.099l0.076 0.299 149.43 507.979c1.1 3.59 1.734 7.716 1.734 11.991 0 7.396-1.897 14.35-5.231 20.4l0.11-0.219c-5.352 9.713-14.134 16.98-24.676 20.239l-0.3 0.080-253.989 74.927c-1.781 0.404-3.827 0.636-5.926 0.636s-4.145-0.232-6.113-0.671l0.186 0.035zM96.516 502.475v2.117l126.995 423.315 173.136-50.798-126.995-427.125zM752.655 822.925c-12.023-0.079-23.777-0.846-35.33-2.263l1.465 0.146c-25.399-3.387-63.921-6.773-108.369-10.583l-66.461-5.926c-15.825-2.135-34.118-3.353-52.696-3.353-27.172 0-53.736 2.607-79.454 7.585l2.615-0.421c-3.053 0.787-6.558 1.239-10.168 1.239-19.144 0-35.32-12.708-40.552-30.148l-0.077-0.3-91.013-309.444c-1.295-3.88-2.042-8.346-2.042-12.987 0-13.392 6.219-25.332 15.926-33.089l0.085-0.065c69.123-58.037 128.809-124.044 178.613-197.311l2.143-3.341c7.008-28.735 11.028-61.725 11.028-95.654 0-14.914-0.777-29.647-2.292-44.16l0.153 1.813c-0.333-2.436-0.524-5.251-0.524-8.11 0-16.689 6.481-31.864 17.065-43.145l-0.032 0.034c23.404-20.778 54.394-33.469 88.349-33.469 0.937 0 1.871 0.010 2.803 0.029l-0.139-0.002c24.38 0.91 46.002 11.994 60.869 29.105l0.088 0.104c30.108 41.23 48.173 92.92 48.173 148.829 0 14.413-1.201 28.546-3.507 42.304l0.206-1.488c-0.737 12.22-2.245 23.539-4.5 34.586l0.267-1.567c0 11.43 0 13.123-2.963 20.319v24.129c41.406 11.102 88.943 17.479 137.97 17.479 8.646 0 17.246-0.198 25.795-0.591l-1.212 0.044h17.779c0.126-0 0.275-0.001 0.424-0.001 77.47 0 140.3 62.682 140.54 140.095l0 0.023c-0.263 31.226-10.888 59.921-28.599 82.866l0.237-0.32c0.607 4.45 0.954 9.592 0.954 14.816s-0.347 10.366-1.018 15.406l0.064-0.59c-1.562 33.564-16.375 63.39-39.287 84.589l-0.081 0.074v2.117c-2.521 42.212-25.94 78.448-59.97 98.744l-0.564 0.312c-1.013 2.384-2.025 5.343-2.846 8.38l-0.117 0.51c-15.663 42.332-58.418 63.921-121.068 63.921zM484.696 717.096c4.75-0.172 10.33-0.269 15.932-0.269 18.099 0 35.96 1.021 53.527 3.007l-2.153-0.198 66.037 5.503c45.718 3.81 84.663 7.196 111.755 10.583 3.478 0.204 7.546 0.32 11.641 0.32s8.163-0.116 12.2-0.346l-0.559 0.025c2.617 0.377 5.639 0.592 8.711 0.592 12.438 0 24.052-3.529 33.894-9.641l-0.274 0.158c1.54-3.851 2.596-8.312 2.954-12.967l0.010-0.156c1.905-16.327 12.857-29.686 27.644-35.042l0.295-0.093c15.020-5.636 25.844-19.151 27.501-35.379l0.015-0.18c0.202-1.399 0.318-3.014 0.318-4.656s-0.115-3.258-0.339-4.838l0.021 0.182c-0.265-1.78-0.416-3.834-0.416-5.923 0-15.411 8.235-28.898 20.545-36.302l0.191-0.107c11.242-6.352 18.933-17.844 19.889-31.2l0.007-0.125c0.028-0.577 0.044-1.253 0.044-1.932 0-6.033-1.262-11.772-3.537-16.966l0.106 0.272c-2.263-5.016-3.581-10.874-3.581-17.040 0-12.343 5.283-23.452 13.71-31.19l0.031-0.028c11.45-9.988 18.645-24.604 18.645-40.901 0-0.503-0.007-1.004-0.020-1.504l0.002 0.074c-1.609-29.566-25.976-52.931-55.8-52.931-0.474 0-0.946 0.006-1.417 0.018l0.070-0.001h-18.626c-185.412 0-218.431-33.865-229.437-45.295-10.651-10.972-17.352-25.83-17.778-42.25l-0.002-0.082v-45.295c0.49-8.742 1.546-16.873 3.149-24.807l-0.186 1.102c0-7.196 2.963-19.049 3.81-27.516 6.35-79.16-14.393-119.375-24.552-126.995-7.030 0.568-13.517 1.768-19.754 3.56l0.705-0.173c1.078 11.974 1.692 25.901 1.692 39.971 0 44.060-6.026 86.712-17.299 127.177l0.791-3.325c-0.979 3.101-2.128 5.763-3.506 8.281l0.119-0.238c-52.396 80.686-112.55 150.259-180.945 210.721l-1.080 0.937 74.927 245.946c15.105-1.616 32.631-2.538 50.372-2.54l0.002-0z",
    BIKE: "M330.323 1024c-182.432 0-330.323-147.89-330.323-330.323s147.89-330.323 330.323-330.323c182.432 0 330.323 147.89 330.323 330.323v0c0 182.432-147.89 330.323-330.323 330.323v0zM330.323 464.993c-126.299 0-228.685 102.386-228.685 228.685s102.386 228.685 228.685 228.685c126.299 0 228.685-102.386 228.685-228.685v0c0-0.151 0.001-0.33 0.001-0.509 0-126.018-102.158-228.177-228.177-228.177-0.179 0-0.358 0-0.536 0.001l0.028-0zM1228.292 1024c-182.432 0-330.323-147.89-330.323-330.323s147.89-330.323 330.323-330.323c182.432 0 330.323 147.89 330.323 330.323v0c0 182.432-147.89 330.323-330.323 330.323v0zM1228.292 464.993c-126.299 0-228.685 102.386-228.685 228.685s102.386 228.685 228.685 228.685c126.299 0 228.685-102.386 228.685-228.685v0c0-0.151 0.001-0.33 0.001-0.509 0-126.018-102.158-228.177-228.177-228.177-0.179 0-0.358 0-0.536 0.001l0.028-0zM1219.653 753.644h-440.6c-0.030 0-0.066 0-0.102 0-19.926 0-37.174-11.468-45.502-28.164l-0.133-0.295-236.816-491.418c-3.59-6.788-5.698-14.838-5.698-23.38 0-28.066 22.752-50.819 50.819-50.819 0.217 0 0.433 0.001 0.649 0.004l-0.033-0h440.091c0.030-0 0.066-0 0.102-0 19.926 0 37.174 11.468 45.502 28.164l0.133 0.295 237.324 492.943c3.098 6.377 4.909 13.873 4.909 21.791 0 20.057-11.619 37.4-28.494 45.665l-0.3 0.133c-6.245 3.205-13.625 5.084-21.444 5.084-0.144 0-0.287-0.001-0.43-0.002l0.022 0zM813.102 652.006h327.782l-188.030-389.272h-329.814zM304.913 753.644c-7.561-0.036-14.72-1.718-21.149-4.704l0.314 0.131c-17.754-8.182-29.855-25.825-29.855-46.294 0-7.53 1.638-14.677 4.576-21.105l-0.13 0.317 296.274-652.006c8.14-17.791 25.769-29.939 46.239-29.983l0.006-0h118.916c28.066 0 50.819 22.752 50.819 50.819s-22.752 50.819-50.819 50.819v0h-85.884l-283.061 622.531c-8.262 17.547-25.798 29.475-46.119 29.475-0.044 0-0.088-0-0.133-0l0.007 0zM1063.131 101.638h-144.326c-28.066 0-50.819-22.752-50.819-50.819s22.752-50.819 50.819-50.819v0h144.326c28.066 0 50.819 22.752 50.819 50.819s-22.752 50.819-50.819 50.819v0zM781.594 734.841c-0.076 0-0.165 0.001-0.255 0.001-28.066 0-50.819-22.752-50.819-50.819 0-6.965 1.401-13.603 3.937-19.647l-0.125 0.335 183.964-450.763c8.021-18.539 26.154-31.274 47.262-31.274 28.359 0 51.348 22.989 51.348 51.348 0 7.251-1.503 14.151-4.214 20.406l0.128-0.332-184.472 449.239c-7.775 18.569-25.752 31.4-46.74 31.508l-0.014 0z",
    ROCKET: "M450.452 1024c-12.377-0.182-23.519-5.323-31.556-13.52l-0.007-0.007c-9.809-8.325-15.992-20.662-15.992-34.444 0-5.266 0.903-10.321 2.562-15.020l-0.097 0.316c12.716-29.734 20.109-64.333 20.109-100.657 0-53.303-15.919-102.887-43.262-144.259l0.607 0.978c-13.613-0.663-26.43-2.598-38.784-5.7l1.359 0.289c-17.093-4.399-30.088-18.148-33.323-35.341l-0.044-0.28c-1.348-14.235-3.417-26.996-6.252-39.465l0.39 2.040c-40.629-26.6-90.398-42.425-143.863-42.425-35.909 0-70.151 7.139-101.383 20.074l1.759-0.645c-5.184 2.253-11.223 3.563-17.567 3.563-18.534 0-34.457-11.183-41.388-27.169l-0.113-0.292c-2.143-5.206-3.387-11.251-3.387-17.585s1.244-12.379 3.501-17.901l-0.114 0.316c17.925-42.664 42.76-79.065 73.476-109.549l0.021-0.021c62.286-62.423 148.406-101.041 243.547-101.041 12.526 0 24.895 0.669 37.075 1.974l-1.513-0.131c31.38-67.145 71.923-124.563 120.853-173.609l-0.011 0.011c103.557-105.369 246.678-171.566 405.264-174.491l0.549-0.008c0.102-0 0.222-0 0.343-0 33.867 0 66.928 3.448 98.852 10.011l-3.153-0.542c18.033 3.61 32.011 17.589 35.573 35.333l0.048 0.288c4.984 28.231 7.833 60.733 7.833 93.902 0 160.114-66.392 304.722-173.148 407.794l-0.165 0.159c-48.616 49.381-105.966 89.993-169.572 119.362l-3.575 1.48c1.185 10.696 1.86 23.099 1.86 35.659 0 95.195-38.816 181.325-101.484 243.424l-0.026 0.025c-30.504 30.737-66.906 55.572-107.373 72.673l-2.197 0.824c-5.186 2.269-11.229 3.595-17.58 3.607l-0.005 0zM395.893 628.107h17.134c13.506 1.003 25.243 7.815 32.832 17.92l0.084 0.116c44.965 58.939 72.043 133.627 72.043 214.64 0 5.547-0.127 11.064-0.378 16.549l0.028-0.778c42.822-45.537 69.133-107.028 69.133-174.664 0-17.977-1.859-35.519-5.394-52.446l0.29 1.659c-0.64-2.847-1.006-6.116-1.006-9.471 0-18.933 11.669-35.141 28.208-41.824l0.303-0.108c68.835-26.923 127.565-65.956 176.279-114.957l0.024-0.024c90.782-87.772 147.142-210.652 147.142-346.697 0-15.257-0.709-30.348-2.095-45.242l0.144 1.909c-13.088-1.257-28.297-1.973-43.674-1.973-135.691 0-258.348 55.807-346.269 145.721l-0.088 0.090c-48.748 48.843-87.848 107.336-114.182 172.364l-1.249 3.489c-6.706 17.018-23.003 28.841-42.061 28.841-3.147 0-6.218-0.322-9.183-0.936l0.292 0.050c-15.944-3.492-34.258-5.493-53.040-5.493-68.057 0-129.978 26.268-176.179 69.218l0.16-0.147c4.195-0.175 9.118-0.274 14.064-0.274 81.775 0 157.194 27.211 217.697 73.072l-0.899-0.653c9.942 7.652 16.565 19.196 17.576 32.311l0.010 0.154v17.585zM734.52 402.656c-0.281 0.003-0.614 0.004-0.947 0.004-30.844 0-58.748-12.589-78.853-32.91l-0.010-0.010c-20.325-20.387-32.892-48.518-32.892-79.584s12.567-59.198 32.895-79.587l-0.003 0.003c20.648-19.93 48.795-32.21 79.81-32.21s59.162 12.28 79.844 32.243l-0.034-0.033c20.031 20.269 32.405 48.143 32.405 78.908 0 61.987-50.233 112.241-112.212 112.275l-0.003 0zM734.52 222.295c-37.305 0.391-67.395 30.723-67.395 68.083 0 18.631 7.483 35.513 19.607 47.807l-0.008-0.008c12.466 11.706 29.291 18.898 47.796 18.898s35.33-7.192 47.833-18.933l-0.037 0.035c12.655-12.374 20.502-29.619 20.502-48.698 0-37.603-30.483-68.086-68.086-68.086-0.074 0-0.149 0-0.223 0l0.012-0zM221.844 868.889c-0.718 0.007-1.568 0.012-2.418 0.012-15.075 0-29.843-1.316-44.195-3.841l1.522 0.222c-9.543-1.505-16.982-8.944-18.471-18.362l-0.016-0.125c-1.995-13.093-3.135-28.199-3.135-43.57 0-86.101 35.752-163.851 93.221-219.215l0.094-0.090c4.097-4.097 9.756-6.63 16.007-6.63 12.502 0 22.637 10.135 22.637 22.637 0 6.251-2.534 11.91-6.63 16.007l0-0c-49.606 47.881-80.408 114.96-80.408 189.234 0 6.239 0.217 12.427 0.645 18.557l-0.046-0.826c5.661 0.436 12.26 0.684 18.917 0.684 73.975 0 140.788-30.661 188.426-79.968l0.072-0.075c4.063-3.985 9.635-6.445 15.782-6.445s11.718 2.46 15.785 6.448l-0.004-0.004c4.21 3.958 6.832 9.564 6.832 15.782s-2.622 11.823-6.821 15.771l-0.011 0.010c-55.496 56.696-132.343 92.301-217.509 93.784l-0.277 0.004z",
    TIE: "M301.89 365.445h-149.69c-15.222-0.003-28.543-8.139-35.854-20.299l-0.105-0.189-54.357-90.734c-3.676-6.098-5.851-13.462-5.851-21.333 0-4.169 0.61-8.196 1.746-11.995l-0.076 0.296 54.357-190.667c5.086-17.767 21.184-30.552 40.268-30.552 0.543 0 1.084 0.010 1.622 0.031l-0.078-0.002h148.018c23.093 0 41.813 18.72 41.813 41.813s-18.72 41.813-41.813 41.813v0h-118.331l-41.813 143.419 33.032 54.775h125.439c23.093 0 41.813 18.72 41.813 41.813s-18.72 41.813-41.813 41.813v0 0zM376.317 365.445h-150.945c-23.093 0-41.813-18.72-41.813-41.813s18.72-41.813 41.813-41.813v0h125.439l32.614-54.775-39.722-143.419h-118.331c-23.093 0-41.813-18.72-41.813-41.813s18.72-41.813 41.813-41.813v0h150.945c0.461-0.018 1.002-0.029 1.545-0.029 19.084 0 35.182 12.785 40.196 30.257l0.072 0.295 54.357 190.667c0.975 3.365 1.536 7.231 1.536 11.228 0 8.065-2.283 15.596-6.238 21.983l0.103-0.179-56.448 90.734c-7.273 12.118-20.223 20.176-35.079 20.488l-0.044 0.001zM262.167 1024c-9.118-0.061-17.531-3.031-24.37-8.027l0.118 0.082-220.354-158.889c-10.628-7.68-17.463-20.037-17.463-33.991 0-2.766 0.269-5.47 0.781-8.086l-0.043 0.265 110.386-501.756c4.345-18.814 20.955-32.627 40.791-32.627 0.359 0 0.717 0.005 1.074 0.014l-0.053-0.001h219.518c0.304-0.008 0.662-0.012 1.022-0.012 19.836 0 36.446 13.813 40.736 32.345l0.055 0.282 109.968 501.756c0.502 2.431 0.79 5.226 0.79 8.087 0 13.795-6.68 26.030-16.983 33.645l-0.114 0.080-221.191 158.889c-6.791 4.965-15.308 7.945-24.521 7.945-0.052 0-0.105-0-0.157-0l0.008 0zM88.644 805.318l173.524 125.439 173.942-125.439-97.006-442.8h-153.454z",
    THUMBS_RIGHT: "M195.365 1023.555c-0.528 0.022-1.147 0.035-1.77 0.035-20.15 0-37.173-13.392-42.652-31.762l-0.081-0.315-149.083-504.657c-1.034-3.576-1.629-7.684-1.629-11.931 0-20.245 13.519-37.333 32.021-42.728l0.315-0.079 254.554-76.099c3.774-1.157 8.112-1.823 12.606-1.823 7.776 0 15.085 1.994 21.446 5.499l-0.23-0.116c10.47 5.642 18.294 15.059 21.724 26.386l0.082 0.315 148.638 506.437c1.254 3.922 1.976 8.434 1.976 13.114 0 19.883-13.039 36.72-31.033 42.427l-0.315 0.086-254.109 75.209c-1.869 0.213-4.036 0.334-6.23 0.334s-4.361-0.121-6.493-0.358l0.263 0.024zM101.465 504.212l122.827 420.548 169.109-49.398-124.607-420.548zM752.090 824.184c-12.010-0.084-23.743-0.89-35.262-2.377l1.441 0.152c-25.366-3.115-64.083-6.675-108.586-10.236l-65.419-5.785c-15.471-2.041-33.362-3.206-51.524-3.206-27.262 0-53.91 2.625-79.707 7.635l2.619-0.424c-3.050 0.746-6.552 1.174-10.154 1.174-20.241 0-37.326-13.514-42.725-32.011l-0.079-0.314-89.005-307.957c-1.458-4.213-2.299-9.068-2.299-14.119 0-13.334 5.864-25.299 15.155-33.455l0.050-0.043c68.189-57.846 127.003-123.731 175.857-196.838l2.153-3.423c7.195-28.893 11.322-62.063 11.322-96.197 0-14.236-0.718-28.304-2.12-42.171l0.143 1.746c-0.235-2.111-0.369-4.558-0.369-7.037 0-17.562 6.737-33.551 17.768-45.523l-0.043 0.047c24.141-21.020 55.908-33.835 90.669-33.835 0.667 0 1.332 0.005 1.997 0.014l-0.101-0.001c24.931 0.837 47.058 12.175 62.211 29.707l0.092 0.109c30.603 41.511 48.978 93.67 48.978 150.121 0 15.040-1.304 29.775-3.806 44.098l0.22-1.524c-0.537 12.009-1.97 23.319-4.245 34.32l0.24-1.388c0 11.126-2.225 13.351-3.115 20.471v17.356c24.031 7.12 93.9 20.471 290.156 20.471 85 0 154.868-2.67 155.313-2.67v0c65.499 4.297 117.105 58.072 117.931 124.080l0.001 0.081c0.002 0.241 0.002 0.525 0.002 0.81 0 68.561-51.68 125.051-118.21 132.64l-0.614 0.057s-95.68-3.115-152.643-3.115c-2.561 32.884-17.439 61.87-39.968 82.698l-0.084 0.076c-2.412 42.55-25.83 79.147-59.967 99.818l-0.556 0.312-1.78 8.010c-9.346 24.921-37.382 65.419-122.827 65.419zM485.076 714.263c3.127-0.072 6.812-0.112 10.506-0.112 19.82 0 39.366 1.173 58.572 3.452l-2.325-0.225 64.973 5.785c44.502 3.56 85.89 7.12 112.146 10.681h22.696c2.074 0.224 4.479 0.352 6.914 0.352 11.99 0 23.256-3.099 33.040-8.54l-0.347 0.177c1.359-3.428 2.171-7.397 2.225-11.548l0-0.022c1.835-17.345 13.397-31.588 29.062-37.284l0.31-0.098c14.493-4.845 24.991-17.737 26.248-33.241l0.009-0.136v-8.455c-0.279-1.871-0.438-4.030-0.438-6.227 0-16.201 8.657-30.38 21.598-38.163l0.201-0.112c10.38-6.042 17.438-16.802 18.24-29.264l0.006-0.107c0.034-0.603 0.053-1.308 0.053-2.018 0-5.545-1.166-10.818-3.265-15.586l0.097 0.248c-2.379-5.273-3.765-11.432-3.765-17.914 0-12.976 5.553-24.655 14.413-32.789l0.032-0.029c14.686-13.351 29.372-14.686 86.335-14.686s149.528 3.115 149.528 3.115c8.9 0 28.037-23.586 28.037-44.502 0.017-0.405 0.026-0.881 0.026-1.359 0-17.628-12.812-32.264-29.633-35.104l-0.209-0.029s-70.314 0-157.093 0c-317.747 0-376.935-29.817-379.16-89.005-0.425-6.651-0.668-14.423-0.668-22.251s0.242-15.599 0.72-23.307l-0.052 1.056c0.306-9.307 1.586-18.163 3.745-26.67l-0.185 0.859c0-7.565 2.67-18.691 3.56-27.146 2.22-10.548 3.492-22.668 3.492-35.085 0-33.162-9.068-64.206-24.86-90.787l0.452 0.821-15.576 2.67c1.012 11.619 1.589 25.14 1.589 38.796 0 43.817-5.94 86.246-17.060 126.526l0.785-3.333c-1.158 3.168-2.358 5.809-3.726 8.346l0.165-0.336c-52.325 80.57-112.009 150.155-179.72 210.983l-0.96 0.848 71.204 242.983c14.686 0 30.707-2.225 48.508-2.225z",
    PEOPLE: "M710.783 473.481c-119.172-6.296-213.419-104.46-213.419-224.637 0-4.060 0.108-8.094 0.32-12.101l-0.024 0.559c-0.228-3.793-0.358-8.227-0.358-12.692 0-120 93.97-218.053 212.339-224.585l0.58-0.026c118.934 6.573 212.888 104.619 212.888 224.609 0 4.267-0.119 8.507-0.353 12.716l0.026-0.584c0.209 3.624 0.327 7.864 0.327 12.132 0 119.99-93.954 218.035-212.307 224.583l-0.581 0.026zM710.783 112.466c-57.084 5.905-101.221 53.749-101.221 111.902 0 3.961 0.205 7.875 0.604 11.73l-0.041-0.483c-0.442 3.744-0.694 8.081-0.694 12.477 0 57.801 43.604 105.418 99.713 111.751l0.513 0.047c56.853-6.144 100.722-53.874 100.722-111.851 0-4.178-0.228-8.303-0.672-12.363l0.045 0.502c0.412-3.615 0.647-7.804 0.647-12.049 0-57.387-42.981-104.734-98.508-111.608l-0.547-0.055zM1008.255 1024h-602.816c-0.041 0-0.089 0-0.138 0-29.671 0-53.976-22.981-56.084-52.114l-0.011-0.182c-4.499-65.23-8.997-128.211-11.809-195.128-0.005-0.55-0.008-1.2-0.008-1.851 0-87.165 53.601-161.811 129.639-192.776l1.391-0.501c71.196-26.456 153.446-41.764 239.271-41.764s168.075 15.308 244.167 43.343l-4.896-1.579c77.714 31.148 131.601 105.841 131.601 193.12 0 0.904-0.006 1.806-0.017 2.707l0.001-0.137-10.122 194.566c-2.119 29.316-26.423 52.297-56.095 52.297-0.048 0-0.097-0-0.145-0l0.007 0zM457.735 911.534h498.223l10.122-142.269c-2.264-36.459-24.408-67.253-55.639-81.851l-0.594-0.249c-59.856-21.907-128.964-34.577-201.032-34.577s-141.176 12.67-205.219 35.905l4.187-1.327c-31.825 14.847-53.969 45.641-56.219 81.824l-0.014 0.276c3.374 46.673 6.186 94.471 9.56 142.269zM1372.644 932.34h-239.552c-15.528 0-28.116-12.588-28.116-28.116s12.588-28.116 28.116-28.116v0h216.496l9.56-141.707c-2.413-41.553-28.614-76.435-65.092-91.405l-0.701-0.255c-50.055-18.352-107.854-29.573-168.091-30.917l-0.608-0.011c-15.528 0-28.116-12.588-28.116-28.116s12.588-28.116 28.116-28.116v0 0c67.902 1.379 132.464 13.835 192.552 35.624l-4.172-1.322c59.401 24.265 100.522 81.541 100.657 148.438l0 0.017-11.809 168.699c-0.911 14.477-12.876 25.874-27.503 25.874-0.216 0-0.431-0.002-0.646-0.007l0.032 0.001zM1188.2 494.849c-84.198-5.663-150.352-75.348-150.352-160.484 0-2.889 0.076-5.761 0.227-8.613l-0.017 0.398c-0.134-2.453-0.21-5.325-0.21-8.214 0-85.136 66.153-154.822 149.861-160.458l0.491-0.026c84.198 5.663 150.352 75.348 150.352 160.484 0 2.889-0.076 5.761-0.227 8.613l0.017-0.398c0.134 2.453 0.21 5.325 0.21 8.214 0 85.136-66.153 154.822-149.861 160.458l-0.491 0.026zM1188.2 213.685c-53.171 5.731-94.205 50.365-94.205 104.584 0 2.774 0.107 5.523 0.318 8.242l-0.022-0.36c-0.214 2.511-0.337 5.434-0.337 8.386 0 54.121 41.106 98.641 93.8 104.043l0.445 0.037c53.139-5.439 94.246-49.959 94.246-104.080 0-2.952-0.122-5.875-0.362-8.764l0.025 0.378c0.188-2.359 0.296-5.108 0.296-7.882 0-54.218-41.034-98.853-93.74-104.543l-0.465-0.041zM281.164 932.34h-241.239c-0.027 0-0.058 0-0.090 0-14.737 0-26.825-11.337-28.020-25.766l-0.007-0.102-11.809-168.699c0.518-66.644 41.21-123.657 99.031-148.056l1.064-0.399c56.091-20.518 120.854-32.978 188.348-34.293l0.595-0.009c15.228 0.549 27.51 12.442 28.672 27.452l0.006 0.102c0.004 0.169 0.006 0.368 0.006 0.568 0 15.333-12.273 27.799-27.531 28.11l-0.029 0c-60.844 1.355-118.644 12.577-172.451 32.119l3.752-1.191c-37.107 15.465-63.141 50.562-65.22 91.973l-0.010 0.249 9.56 141.707h215.372c15.528-0 28.116 12.588 28.116 28.116s-12.588 28.116-28.116 28.116h0zM224.931 494.849c-84.198-5.663-150.352-75.348-150.352-160.484 0-2.889 0.076-5.761 0.227-8.613l-0.017 0.398c-0.153-2.622-0.24-5.688-0.24-8.774 0-85.147 66.169-154.839 149.892-160.46l0.49-0.026c84.155 5.358 150.38 74.925 150.38 159.959 0 3.074-0.087 6.129-0.257 9.16l0.019-0.421c0.172 2.78 0.27 6.029 0.27 9.3 0 85.045-66.243 154.618-149.946 159.937l-0.466 0.024zM224.931 213.685c-53.171 5.731-94.205 50.365-94.205 104.584 0 2.774 0.107 5.523 0.318 8.242l-0.022-0.36c-0.214 2.511-0.337 5.434-0.337 8.386 0 54.121 41.106 98.641 93.8 104.043l0.445 0.037c53.139-5.439 94.246-49.959 94.246-104.080 0-2.952-0.122-5.875-0.362-8.764l0.025 0.378c0.19-2.376 0.298-5.145 0.298-7.939 0-54.331-40.985-99.090-93.725-105.045l-0.483-0.044z",
    HUMAN: "M88.773 1024h-88.773c5.842-167.006 142.634-300.173 310.528-300.173 3.028 0 6.047 0.043 9.054 0.129l-0.442-0.010v88.773c-2.589-0.108-5.628-0.17-8.681-0.17-118.883 0-215.934 93.475-221.666 210.937l-0.020 0.514zM996.036 1024h-88.773c-5.751-117.976-102.802-211.45-221.686-211.45-3.053 0-6.092 0.062-9.115 0.184l0.434-0.014v-88.773c2.566-0.076 5.584-0.119 8.612-0.119 167.894 0 304.686 133.167 310.513 299.64l0.015 0.533zM498.018 757.68v0c-133.16 0-240.132-130.941-281.411-349.323-6.129-25.266-9.644-54.273-9.644-84.1 0-85.688 29.010-164.601 77.744-227.453l-0.632 0.847c48.15-59.651 121.264-97.486 203.215-97.486 4.242 0 8.46 0.101 12.652 0.302l-0.592-0.023h12.872c79.905 1.798 150.744 39.115 197.585 96.725l0.379 0.481c48.228 62.26 77.31 141.468 77.31 227.468 0 29.514-3.425 58.229-9.9 85.767l0.501-2.529c-41.723 218.826-146.92 349.767-281.855 349.767zM483.814 44.831c-66.822 1.458-126.075 32.65-165.245 80.825l-0.317 0.402c-41.797 54.377-66.985 123.417-66.985 198.339 0 26.797 3.222 52.841 9.299 77.766l-0.461-2.239c37.285 196.189 126.058 313.37 237.912 313.37s200.628-116.293 237.912-313.37c5.789-22.977 9.111-49.355 9.111-76.508 0-74.933-25.297-143.958-67.818-199l0.56 0.755c-39.699-49.542-100.2-80.994-168.048-80.994-3.341 0-6.664 0.076-9.968 0.227l0.469-0.017zM210.837 383.057h-4.883c-22.193 6.658-24.413 64.361-7.99 122.951s36.397 83.891 51.489 83.891h3.551c15.091-5.326 21.749-44.387 11.541-105.64s-32.846-101.202-53.708-101.202zM785.2 383.057c-20.862 0-44.387 44.387-53.708 101.645s-3.551 100.314 11.541 105.64h3.551c15.091 0 35.953-30.183 51.489-83.891s14.204-116.293-7.99-122.951h-4.883zM549.063 19.086h-149.583c-40.508 4.422-75.118 26.43-96.462 58.116l-0.301 0.475c-15.705 10.222-27.266 25.678-32.276 43.851l-0.126 0.536-3.995 23.081c-7.756 17.105-12.321 37.079-12.428 58.108l-0 0.039c-10.163 34.654-16.010 74.466-16.010 115.643 0 1.789 0.011 3.576 0.033 5.36l-0.003-0.271h4.439c7.102 0 20.862-5.326 25.744-44.387 3.107-24.857 0-54.152 3.551-79.896 26.986-26.799 62.77-44.769 102.64-49.199l0.781-0.070c24.413 12.872 46.606 15.979 68.799 27.52 13.414 5.797 29.034 9.169 45.441 9.169 2.909 0 5.793-0.106 8.649-0.314l-0.382 0.022c1.757 0.090 3.814 0.142 5.884 0.142 16.601 0 32.429-3.314 46.857-9.317l-0.808 0.298c20.418-12.428 41.723-15.535 65.692-28.407v0c41.808 4.174 78.639 22.731 106.063 50.579l0.021 0.022c2.219 25.744 0 55.039 3.551 79.896 4.883 39.060 18.642 44.387 25.744 44.387h3.995c0.019-1.513 0.030-3.3 0.030-5.089 0-41.177-5.847-80.989-16.755-118.649l0.746 3.007c-0.107-21.068-4.672-41.042-12.799-59.065l0.37 0.918c-1.12-8.907-2.831-16.872-5.154-24.572l0.271 1.047c-5.483-18.661-17.134-34.057-32.548-44.203l-0.298-0.184c-21.596-31.057-55.433-52.306-94.374-56.758l-0.613-0.057h-44.387zM336.007 497.13v0c-30.081-0.242-57.143-12.966-76.298-33.239l-0.047-0.051c-15.725-16.005-25.432-37.968-25.432-62.198 0-1.698 0.048-3.384 0.142-5.059l-0.010 0.232v-18.642c-0.424-2.668-0.666-5.744-0.666-8.877s0.242-6.209 0.709-9.211l-0.043 0.334 2.663-12.428 11.984-3.995c30.343-10.34 65.297-16.309 101.645-16.309s71.302 5.969 103.936 16.979l-2.29-0.671 11.984 3.995 2.663 12.428c1.090 5.023 1.883 10.96 2.207 17.021l0.012 0.29v17.755c0.012 0.546 0.019 1.189 0.019 1.834 0 24.173-9.662 46.090-25.335 62.099l0.015-0.016c-19.562 20.595-46.742 33.791-77.005 35.058l-0.227 0.008zM278.748 382.169v17.755c-0.015 0.456-0.024 0.991-0.024 1.529 0 12.998 5.079 24.81 13.361 33.559l-0.021-0.022c11.307 11.555 26.974 18.805 44.334 19.086l0.052 0.001h34.178c17.604-0.981 33.212-8.799 44.348-20.819l0.039-0.042c8.237-8.065 13.344-19.299 13.344-31.725 0-0.55-0.010-1.098-0.030-1.643l0.002 0.079v-15.979c-22.292-6.338-47.894-9.982-74.348-9.982s-52.056 3.644-76.332 10.458l1.984-0.476zM625.852 497.13v0c-30.081-0.242-57.143-12.966-76.298-33.239l-0.047-0.051c-15.725-16.005-25.432-37.968-25.432-62.198 0-1.698 0.048-3.384 0.142-5.059l-0.010 0.232v-35.953l2.663-12.872 12.428-3.995c30.343-10.34 65.297-16.309 101.645-16.309s71.302 5.969 103.936 16.979l-2.29-0.671 11.984 4.439 2.663 12.428c-0.054 0.822-0.085 1.783-0.085 2.75 0 5.051 0.844 9.905 2.398 14.429l-0.093-0.312v22.193c0.028 0.831 0.044 1.807 0.044 2.787 0 23.28-8.961 44.467-23.622 60.3l0.053-0.058c-19.445 21.092-46.901 34.545-77.506 35.505l-0.171 0.004zM568.593 382.169v17.755c-0.096 1.097-0.151 2.374-0.151 3.663 0 12.487 5.157 23.771 13.457 31.836l0.011 0.010c11.307 11.555 26.974 18.805 44.334 19.086l0.052 0.001h34.178c17.553-1.219 33.089-8.979 44.36-20.833l0.027-0.029c7.995-8.026 12.938-19.097 12.938-31.323 0-0.848-0.024-1.69-0.071-2.527l0.005 0.116v-15.979c-22.292-6.338-47.894-9.982-74.348-9.982s-52.056 3.644-76.332 10.458l1.984-0.476z",
    FEET: "M403.197 1023.135v0c-37.478-0.097-71.040-16.783-93.742-43.101l-0.135-0.16-102.53-124.161c-45.554-64.599-83.061-139.205-108.7-219.125l-1.617-5.835-21.631-90.849c-2.238-10.334-3.521-22.205-3.521-34.375 0-51.856 23.275-98.276 59.948-129.383l0.245-0.203 193.379-158.77c16.518-10.463 36.629-16.673 58.191-16.673 39.135 0 73.491 20.458 92.958 51.263l0.267 0.452c4.716 7.219 8.684 15.533 11.483 24.369l0.198 0.723 11.248 33.744c7.824 26.376 12.326 56.681 12.326 88.037s-4.502 61.661-12.895 90.304l0.569-2.266-35.474 104.693c-3.344 12.828-5.263 27.554-5.263 42.729 0 25.547 5.441 49.824 15.227 71.734l-0.446-1.118 54.942 107.289c9.843 18.508 15.623 40.469 15.623 63.78 0 40.765-17.675 77.401-45.779 102.665l-0.127 0.112-25.524 21.198c-18.929 14.838-43.085 23.794-69.334 23.794-0.112 0-0.223-0-0.335-0l0.017 0zM380.701 279.037c-0.822-0.404-1.789-0.641-2.812-0.641s-1.99 0.237-2.85 0.658l0.038-0.017-192.946 161.365c-17.853 16.774-28.973 40.536-28.973 66.896 0 5.405 0.468 10.701 1.364 15.85l-0.079-0.548 21.631 90.849c24.538 72.436 56.029 135.257 94.814 192.752l-1.802-2.834 102.962 123.728c7.673 8.715 18.72 14.303 31.079 14.707l0.070 0.002c0.216 0.006 0.47 0.009 0.724 0.009 6.617 0 12.7-2.285 17.503-6.11l-0.057 0.044 25.957-20.766c9.592-10.191 15.486-23.958 15.486-39.101 0-9.924-2.531-19.256-6.983-27.387l0.149 0.297-54.942-107.289c-15.185-31.42-24.059-68.328-24.059-107.31 0-25.281 3.732-49.691 10.676-72.707l-0.461 1.78 35.042-104.693c5.36-18.676 8.443-40.126 8.443-62.297s-3.083-43.621-8.843-63.946l0.4 1.649-11.681-30.283c-4.397-12.808-15.94-22.020-29.75-22.923l-0.101-0.005zM427.424 62.729c1.495 5.437 2.354 11.679 2.354 18.123 0 32.478-21.823 59.859-51.604 68.28l-0.5 0.121c-2.752 0.378-5.932 0.594-9.162 0.594-36.191 0-66.054-27.098-70.404-62.112l-0.035-0.346c-1.495-5.437-2.354-11.679-2.354-18.123 0-32.478 21.823-59.859 51.604-68.28l0.5-0.121c2.82-0.397 6.078-0.624 9.388-0.624 35.588 0 65.057 26.203 70.165 60.368l0.048 0.389zM285.526 140.167c1.671 5.344 2.634 11.489 2.634 17.858 0 27.696-18.201 51.142-43.294 59.028l-0.438 0.119h-2.163c-2.067 0.248-4.461 0.39-6.888 0.39-31.235 0-56.986-23.476-60.572-53.746l-0.028-0.288c-1.62-5.207-2.553-11.194-2.553-17.398 0-28.21 19.287-51.916 45.394-58.65l0.42-0.092c1.986-0.228 4.287-0.358 6.619-0.358 31.002 0 56.641 22.965 60.831 52.812l0.037 0.324zM181.266 239.236c0.845 3.595 1.329 7.723 1.329 11.963 0 24.88-16.668 45.866-39.447 52.402l-0.385 0.094c-2.374 0.369-5.112 0.58-7.899 0.58-26.245 0-48.124-18.697-53.043-43.498l-0.057-0.344c-1.153-4.167-1.815-8.953-1.815-13.893 0-24.974 16.93-45.995 39.939-52.21l0.379-0.087c2.176-0.308 4.689-0.483 7.243-0.483 26.914 0 49.272 19.505 53.709 45.151l0.047 0.325zM91.714 346.957c0.973 3.628 1.532 7.793 1.532 12.089 0 22.226-14.965 40.956-35.368 46.665l-0.341 0.081c-2.455 0.441-5.28 0.693-8.165 0.693-23.64 0-43.325-16.929-47.594-39.325l-0.048-0.303c-1.235-4.072-1.947-8.751-1.947-13.596 0-22.534 15.382-41.475 36.219-46.895l0.337-0.074c2.134-0.33 4.595-0.518 7.1-0.518 24.28 0 44.425 17.7 48.237 40.901l0.038 0.283zM718.141 1023.135c-0.409 0.006-0.892 0.009-1.375 0.009-25.765 0-49.434-8.974-68.053-23.966l0.209 0.163-25.957-21.198c-28.231-25.375-45.906-62.012-45.906-102.777 0-23.311 5.78-45.273 15.985-64.529l-0.362 0.749 54.942-107.289c9.34-20.792 14.781-45.069 14.781-70.616 0-15.175-1.92-29.901-5.529-43.95l0.266 1.221-35.474-104.693c-7.824-26.376-12.326-56.681-12.326-88.037s4.502-61.661 12.895-90.304l-0.569 2.266 11.248-33.744c15.591-45.467 57.544-77.751 107.173-78.734l0.116-0.002c0.050-0 0.109-0 0.168-0 20.088 0 38.661 6.489 53.737 17.486l-0.26-0.181 196.84 162.663c36.129 30.822 58.891 76.393 58.891 127.28 0 12.069-1.28 23.839-3.713 35.182l0.197-1.096-22.063 93.012c-27.416 85.421-64.751 159.71-111.675 226.797l1.791-2.703-102.53 122.863c-22.523 26.536-55.903 43.263-93.19 43.263-0.242 0-0.483-0.001-0.725-0.002l0.037 0zM740.637 279.037c-13.911 0.909-25.454 10.121-29.779 22.691l-0.071 0.237-11.248 33.744c-5.154 18.688-8.117 40.146-8.117 62.297s2.962 43.609 8.512 64.001l-0.395-1.704 34.609 102.962c6.18 20.866 9.736 44.839 9.736 69.643 0 38.781-8.693 75.532-24.237 108.41l0.657-1.545-54.942 109.019c-4.303 7.833-6.834 17.166-6.834 27.089 0 15.143 5.894 28.91 15.514 39.13l-0.027-0.029 25.957 20.766c4.746 3.781 10.829 6.066 17.446 6.066 0.255 0 0.508-0.003 0.761-0.010l-0.037 0.001c12.649-0.396 23.877-6.162 31.532-15.084l0.049-0.058 102.53-122.863c36.475-54.414 67.918-116.894 91.222-183.206l1.79-5.847 22.063-94.743c0.716-4.314 1.124-9.285 1.124-14.351 0-25.491-10.351-48.565-27.079-65.248l-0.002-0.002-196.84-161.365zM693.915 61.864c-1.495 5.437-2.354 11.679-2.354 18.123 0 32.478 21.823 59.859 51.604 68.28l0.5 0.121c3.025 0.46 6.516 0.722 10.068 0.722 35.845 0 65.443-26.745 69.928-61.368l0.037-0.354c1.495-5.437 2.354-11.679 2.354-18.123 0-32.478-21.823-59.859-51.604-68.28l-0.5-0.121c-3.077-0.476-6.627-0.747-10.24-0.747-35.393 0-64.696 26.075-69.747 60.063l-0.047 0.386zM835.812 140.167c-0.745 3.472-1.171 7.461-1.171 11.55 0 31.777 25.761 57.538 57.538 57.538 23.766 0 44.167-14.409 52.942-34.968l0.143-0.376c1.179-3.619 2.093-7.872 2.57-12.257l0.025-0.289c1.268-4.644 1.996-9.975 1.996-15.477 0-28.091-18.988-51.747-44.83-58.833l-0.428-0.1c-2.355-0.32-5.077-0.502-7.841-0.502-31.207 0-56.979 23.27-60.912 53.405l-0.033 0.31zM940.073 239.236c-0.707 3.186-1.112 6.845-1.112 10.599 0 28.21 22.869 51.079 51.079 51.079 24.456 0 44.898-17.188 49.905-40.142l0.062-0.337c1.734-4.916 2.736-10.585 2.736-16.488 0-28.193-22.855-51.049-51.049-51.049-23.124 0-42.656 15.375-48.933 36.459l-0.092 0.361c-1.073 3.037-1.84 6.565-2.152 10.223l-0.011 0.16zM1029.624 346.957c-2.705 5.64-4.285 12.261-4.285 19.251 0 25.065 20.319 45.384 45.384 45.384 18.075 0 33.682-10.566 40.981-25.859l0.118-0.274c2.735-5.731 4.333-12.456 4.333-19.554 0-0.274-0.002-0.547-0.007-0.82l0.001 0.041c2.705-5.64 4.285-12.261 4.285-19.251 0-25.065-20.319-45.384-45.384-45.384-18.075 0-33.682 10.566-40.981 25.859l-0.118 0.274c-2.735 5.731-4.333 12.456-4.333 19.554 0 0.274 0.002 0.547 0.007 0.82l-0.001-0.041z",
    PHONE: "M808.003 1024c-219.355-6.686-415.61-100.328-556.464-247.443l-0.278-0.292-3.526-3.526c-151.164-144.157-245.756-346.485-247.732-570.922l-0.003-0.367v-14.988l9.698-10.139c14.299-17.429 28.711-33.098 43.95-47.921l0.131-0.127c51.222-52.448 113.032-94.306 182.002-122.15l3.578-1.276c8.534-3.006 18.374-4.775 28.619-4.849l0.034-0c23.804 0 77.142 11.902 90.807 49.371 23.804 67.003 54.22 154.283 76.701 237.596 1.465 6.6 2.304 14.18 2.304 21.957 0 31.124-13.44 59.108-34.833 78.467l-0.091 0.081-78.023 49.371c1.363 10.204 5.126 19.331 10.7 27.065l-0.121-0.176c33.312 44.964 67.861 84.686 105.238 121.55l0.116 0.114c36.669 36.536 76.094 70.368 117.914 101.136l2.868 2.014c6.775 5.324 15.287 8.724 24.569 9.252l0.117 0.005 26.889-37.469 24.685-39.232c19.342-21.207 47.090-34.461 77.934-34.461 1.427 0 2.847 0.028 4.26 0.085l-0.203-0.006c2.518-0.421 5.418-0.662 8.375-0.662s5.858 0.241 8.684 0.703l-0.309-0.042c91.821 18.64 172.93 45.583 249.381 80.897l-6.936-2.873c27.883 19.141 45.935 50.845 45.935 86.766 0 11.364-1.807 22.306-5.149 32.554l0.209-0.742c-28.911 72.791-70.475 134.878-122.504 186.422l-0.041 0.041c-15.157 15.294-31.111 29.711-47.829 43.22l-1.101 0.861-11.461 9.257zM88.162 220.405c8.538 193.029 91.29 365.213 220.207 489.99l0.198 0.19 4.408 4.408c124.535 130.269 297.456 213.376 489.796 220.368l1.266 0.036c10.139-8.375 20.277-17.632 29.534-26.449 43.239-43.308 77.662-95.431 100.338-153.441l1.049-3.046-3.967-9.698c-61.914-28.297-134.322-52.036-209.717-67.606l-6.721-1.16h-9.257l-44.081 69.648c-19.953 24.036-49.839 39.228-83.273 39.228-26.43 0-50.643-9.494-69.413-25.258l0.166 0.136c-48.879-36.218-92.013-72.922-132.563-112.275l0.32 0.309c-39.457-39.614-76.16-82.048-109.751-126.945l-2.214-3.093c-16.186-20.782-25.95-47.258-25.95-76.015 0-7.249 0.62-14.353 1.811-21.262l-0.105 0.739c4.816-23.942 18.785-43.968 38.020-56.66l0.33-0.205 69.648-44.081c0.139-1.453 0.219-3.142 0.219-4.849s-0.080-3.396-0.235-5.062l0.016 0.213c-18.073-72.734-44.081-152.079-68.325-215.556-3.404-1.896-7.353-3.547-11.494-4.748l-0.408-0.101c-59.746 24.235-110.755 58.41-153.411 100.955l0.010-0.010q-13.224 13.224-26.449 29.093z",
    MAIL: "M1265.812 1024h-1120.231c-80.402 0-145.581-65.179-145.581-145.581v-732.839c-0-80.402 65.179-145.581 145.581-145.581l0 0h1120.231c80.402-0 145.581 65.179 145.581 145.581v732.839c0 80.402-65.179 145.581-145.581 145.581v0zM145.581 123.373c-12.265 0-22.207 9.943-22.207 22.207v0 732.839c0 12.265 9.943 22.207 22.207 22.207v0h1120.231c12.265 0 22.207-9.943 22.207-22.207v0 0-732.839c0-12.265-9.943-22.207-22.207-22.207v0h-1120.231zM1265.812 993.157h-1120.231c-48.571-0.056-90.030-30.446-106.454-73.243l-0.264-0.782c-1.459-3.383-2.307-7.322-2.307-11.458 0-8.969 3.988-17.007 10.288-22.437l0.038-0.032 437.359-391.711c5.427-5.235 12.824-8.461 20.973-8.461s15.546 3.225 20.983 8.469l-0.009-0.009c5.416 5.461 8.762 12.98 8.762 21.282s-3.347 15.821-8.764 21.284l0.002-0.002-419.47 378.14c9.529 10.621 23.299 17.273 38.623 17.273 0.084 0 0.169-0 0.253-0.001l-0.013 0h1120.231c0.071 0 0.156 0.001 0.24 0.001 15.323 0 29.093-6.651 38.58-17.224l0.043-0.048-423.171-377.523c-4.585-5.271-7.38-12.204-7.38-19.791 0-9.404 4.294-17.805 11.029-23.348l0.052-0.042c5.356-4.602 12.375-7.404 20.048-7.404s14.692 2.802 20.089 7.439l-0.041-0.034 442.294 394.178c6.482 5.683 10.551 13.98 10.551 23.228 0 3.842-0.702 7.519-1.986 10.912l0.070-0.212c-17.050 43.552-58.632 73.867-107.315 74.024l-0.020 0zM705.696 716.183c-7.851-0.163-14.968-3.177-20.386-8.045l0.029 0.026-638.458-569.369c-6.15-5.757-9.983-13.925-9.983-22.988 0-3.928 0.72-7.689 2.035-11.156l-0.072 0.216c16.688-43.578 58.147-73.969 106.711-74.024l1120.238-0c48.702 0.157 90.285 30.472 107.064 73.24l0.271 0.784c1.213 3.18 1.915 6.858 1.915 10.699 0 9.248-4.070 17.545-10.516 23.198l-0.035 0.030-638.458 569.369c-5.389 4.842-12.506 7.856-20.324 8.019l-0.033 0.001zM106.718 109.802l598.978 534.207 598.978-534.207c-9.529-10.621-23.299-17.273-38.623-17.273-0.084 0-0.169 0-0.253 0.001l0.013-0h-1120.231c-0.071-0-0.156-0.001-0.24-0.001-15.323 0-29.093 6.651-38.58 17.224l-0.043 0.048z",
    PLUS: "M512.214 1024c-23.692 0-42.899-19.207-42.899-42.899v0-938.202c0-23.692 19.207-42.899 42.899-42.899s42.899 19.207 42.899 42.899v0 938.202c0 23.692-19.207 42.899-42.899 42.899v0zM981.53 555.114h-938.631c-23.692 0-42.899-19.207-42.899-42.899s19.207-42.899 42.899-42.899v0h938.631c23.692 0 42.899 19.207 42.899 42.899s-19.207 42.899-42.899 42.899v0z",
    CHECK: "M399.002 1024c-0.095 0.001-0.208 0.001-0.321 0.001-14.784 0-28.125-6.175-37.586-16.086l-0.019-0.020-343.931-361.076c-10.608-9.568-17.246-23.361-17.246-38.705 0-28.749 23.306-52.055 52.055-52.055 13.405 0 25.627 5.067 34.855 13.391l-0.046-0.041 5.195 5.715 303.927 318.474 722.671-880.609c9.085-7.972 21.069-12.836 34.19-12.836 28.693 0 51.953 23.26 51.953 51.953 0 9.714-2.666 18.805-7.306 26.581l0.131-0.238-758.519 926.847c-9.285 11.104-22.988 18.245-38.369 18.701l-0.076 0.002z",
    BOOK: "M844.196 1023.071h-657.887c-102.639 0-185.844-83.205-185.844-185.844v0-54.359c0-102.639 83.205-185.844 185.844-185.844v0h657.887c25.66 0 46.461 20.801 46.461 46.461s-20.801 46.461-46.461 46.461v0h-657.887c-51.319 0-92.922 41.603-92.922 92.922v0 54.359c0 51.319 41.603 92.922 92.922 92.922v0h657.887c25.66 0 46.461 20.801 46.461 46.461s-20.801 46.461-46.461 46.461v0zM298.744 173.299c-7.126-0.239-13.801-1.926-19.819-4.776l0.305 0.13c-15.595-7.715-26.13-23.515-26.13-41.776 0-7.457 1.757-14.505 4.88-20.75l-0.122 0.269c30.499-62.535 93.4-104.966 166.264-105.466l0.067-0h669.503c25.66 0 46.461 20.801 46.461 46.461s-20.801 46.461-46.461 46.461v0h-669.503c-36.601 0.016-68.252 21.191-83.387 51.955l-0.243 0.546c-7.504 15.938-23.373 26.804-41.796 26.947l-0.019 0zM62.722 762.889c-5.785-0.38-11.161-1.711-16.114-3.838l0.317 0.121c-17.926-6.714-30.456-23.703-30.456-43.617 0-6.389 1.29-12.477 3.623-18.017l-0.114 0.306 237.88-592.377c7.102-17.368 23.868-29.382 43.441-29.382 25.85 0 46.805 20.955 46.805 46.805 0 6.277-1.236 12.265-3.477 17.735l0.113-0.312-238.809 593.307c-7.024 17.296-23.695 29.27-43.164 29.27-0.016 0-0.032-0-0.047-0l0.002 0zM855.811 1023.071c-2.863 0.627-6.152 0.987-9.525 0.987s-6.661-0.359-9.83-1.042l0.306 0.055c-17.111-7.109-28.925-23.687-28.925-43.024 0-6.261 1.238-12.233 3.484-17.684l-0.113 0.309 239.274-595.63c7.026-17.32 23.717-29.312 43.209-29.312 25.683 0 46.503 20.82 46.503 46.503 0 6.191-1.21 12.099-3.406 17.502l0.112-0.311-238.345 593.307c-7.243 16.786-23.644 28.325-42.742 28.341l-0.002 0zM844.196 689.016c-6.549-0.013-12.776-1.379-18.42-3.833l0.3 0.116c-16.897-7.204-28.527-23.674-28.527-42.86 0-6.323 1.263-12.352 3.551-17.847l-0.113 0.307 249.96-594.701c6.845-17.671 23.706-29.973 43.441-29.973 25.663 0 46.467 20.804 46.467 46.467 0 5.928-1.11 11.597-3.134 16.811l0.108-0.317v3.252l-250.889 595.165c-7.243 16.786-23.644 28.325-42.742 28.341l-0.002 0zM812.138 790.766h-633.263c-12.726-0.255-22.975-10.505-23.23-23.206l-0-0.024c0-12.83 10.401-23.23 23.23-23.23v0h633.263c12.83 0 23.23 10.401 23.23 23.23v0c0 12.83-10.401 23.23-23.23 23.23v0zM812.138 874.86h-633.263c-12.83 0-23.23-10.401-23.23-23.23s10.401-23.23 23.23-23.23v0h633.263c12.83 0 23.23 10.401 23.23 23.23v0c0.012 0.277 0.019 0.602 0.019 0.929 0 12.83-10.401 23.23-23.23 23.23-0.007 0-0.013-0-0.020-0l0.001 0z",
    CLOCK: "M512.439 1024c-0.13 0-0.284 0-0.439 0-282.77 0-512-229.23-512-512s229.23-512 512-512c282.616 0 511.75 228.98 512 511.537l0 0.024c0 0.13 0 0.285 0 0.439 0 282.616-228.98 511.75-511.537 512l-0.024 0zM512.439 88.185c-0.13-0-0.284-0-0.439-0-234.309 0-424.254 189.945-424.254 424.254s189.945 424.254 424.254 424.254c234.154 0 424.003-189.695 424.253-423.791l0-0.024c-0.248-234.143-189.742-423.945-423.744-424.692l-0.071-0zM512.439 556.312c-24.23 0-43.873-19.643-43.873-43.873v0-316.764c0-24.23 19.643-43.873 43.873-43.873s43.873 19.643 43.873 43.873v0 316.764c0 24.23-19.643 43.873-43.873 43.873v0zM512.439 117.58c-24.23 0-43.873-19.643-43.873-43.873v0-29.395c0-24.23 19.643-43.873 43.873-43.873s43.873 19.643 43.873 43.873v0 28.518c0 24.23-19.643 43.873-43.873 43.873v0zM512.439 1024.877c-24.23 0-43.873-19.643-43.873-43.873v0-28.518c0-24.23 19.643-43.873 43.873-43.873s43.873 19.643 43.873 43.873v0 28.518c-0.492 23.85-19.942 42.996-43.864 42.996-0.003 0-0.006-0-0.009-0l0.001 0zM980.127 556.312h-28.518c-24.23 0-43.873-19.643-43.873-43.873s19.643-43.873 43.873-43.873v0h28.518c24.23 0 43.873 19.643 43.873 43.873s-19.643 43.873-43.873 43.873v0zM72.829 556.312h-28.518c-24.23 0-43.873-19.643-43.873-43.873s19.643-43.873 43.873-43.873v0h28.518c24.23 0 43.873 19.643 43.873 43.873s-19.643 43.873-43.873 43.873v0zM711.623 188.655c-3.445-0.38-6.569-1.473-9.316-3.129l0.103 0.057c-6.625-3.966-10.991-11.104-10.991-19.262 0-3.871 0.983-7.513 2.713-10.689l-0.058 0.117 11.407-23.692c3.984-6.542 11.077-10.843 19.175-10.843 4.083 0 7.91 1.093 11.205 3.004l-0.107-0.057c6.676 3.735 11.114 10.761 11.114 18.824 0 3.886-1.031 7.53-2.834 10.676l0.055-0.105-12.723 21.937c-3.863 6.604-10.921 10.97-18.999 10.97-0.107 0-0.215-0.001-0.322-0.002l0.016 0zM299.654 902.471c-3.902-0.145-7.512-1.268-10.632-3.128l0.103 0.057c-6.625-3.966-10.991-11.104-10.991-19.262 0-3.871 0.983-7.513 2.713-10.689l-0.058 0.117 12.723-22.375c3.922-6.813 11.162-11.326 19.457-11.326 3.794 0 7.367 0.944 10.498 2.61l-0.121-0.059c6.676 3.735 11.114 10.761 11.114 18.824 0 3.886-1.031 7.53-2.834 10.676l0.055-0.105-12.723 22.375c-3.668 7.155-10.888 12.024-19.27 12.284l-0.034 0.001zM880.096 746.283c-0.178 0.006-0.387 0.010-0.597 0.010-3.712 0-7.155-1.153-9.99-3.119l0.058 0.038-22.375-12.723c-6.727-3.943-11.172-11.137-11.172-19.369 0-4.004 1.052-7.763 2.894-11.015l-0.058 0.111c3.984-6.542 11.077-10.843 19.175-10.843 4.083 0 7.91 1.093 11.205 3.004l-0.107-0.057 21.937 12.723c6.727 3.943 11.172 11.137 11.172 19.369 0 4.004-1.052 7.763-2.894 11.015l0.058-0.111c-3.863 6.604-10.921 10.97-18.999 10.97-0.107 0-0.215-0.001-0.322-0.002l0.016 0zM166.718 334.752c-0.115 0.002-0.251 0.004-0.387 0.004-3.926 0-7.585-1.146-10.66-3.122l0.078 0.047-23.692-12.723c-6.542-3.984-10.843-11.077-10.843-19.175 0-4.083 1.093-7.91 3.004-11.205l-0.057 0.107c3.735-6.676 10.761-11.114 18.824-11.114 3.886 0 7.53 1.031 10.676 2.834l-0.105-0.055 21.937 12.723c6.676 3.735 11.114 10.761 11.114 18.824 0 3.886-1.031 7.53-2.834 10.676l0.055-0.105c-3.576 6.828-10.612 11.408-18.717 11.408-0.052 0-0.104-0-0.156-0.001l0.008 0zM312.816 188.655c-8.36-0.415-15.452-5.45-18.809-12.589l-0.057-0.134-13.162-22.375c-1.427-2.83-2.262-6.169-2.262-9.702 0-12.115 9.821-21.937 21.937-21.937 7.736 0 14.537 4.005 18.443 10.054l0.052 0.086 12.723 22.375c1.883 3.131 2.997 6.91 2.997 10.95 0 7.796-4.15 14.622-10.36 18.392l-0.096 0.054c-2.912 1.932-6.489 3.082-10.334 3.082-0.223 0-0.446-0.004-0.667-0.012l0.032 0.001zM724.785 902.471c-8.026-0.050-15.024-4.402-18.809-10.865l-0.056-0.104-12.723-22.375c-1.853-3.188-2.946-7.015-2.946-11.098 0-8.098 4.302-15.191 10.745-19.119l0.099-0.056c3.163-1.934 6.991-3.079 11.087-3.079 8.007 0 14.992 4.378 18.692 10.87l0.056 0.106 13.162 22.375c1.853 3.188 2.946 7.015 2.946 11.098 0 8.098-4.302 15.191-10.745 19.119l-0.099 0.056c-3.3 1.809-7.208 2.929-11.364 3.070l-0.043 0.001zM144.343 746.283c-0.044 0-0.096 0.001-0.148 0.001-8.106 0-15.141-4.579-18.662-11.292l-0.055-0.116c-1.937-3.204-3.082-7.075-3.082-11.213 0-7.536 3.8-14.184 9.588-18.133l0.076-0.049 22.814-12.723c2.83-1.427 6.169-2.262 9.702-2.262 12.115 0 21.937 9.821 21.937 21.937 0 7.736-4.005 14.537-10.054 18.443l-0.086 0.052-22.375 12.723c-2.996 1.929-6.655 3.075-10.581 3.075-0.136 0-0.272-0.001-0.407-0.004l0.020 0zM858.159 334.752c-0.167 0.005-0.365 0.007-0.562 0.007-12.115 0-21.937-9.821-21.937-21.937 0-8.303 4.613-15.529 11.416-19.254l0.114-0.057 21.937-12.723c3.188-1.853 7.015-2.946 11.098-2.946 8.098 0 15.191 4.302 19.119 10.745l0.056 0.099c1.934 3.163 3.079 6.991 3.079 11.087 0 8.007-4.378 14.992-10.87 18.692l-0.106 0.056-21.937 12.723c-3.255 2.019-7.162 3.297-11.35 3.508l-0.057 0.002zM379.942 688.809c-23.97-0.339-43.271-19.85-43.271-43.869 0-11.748 4.618-22.418 12.137-30.294l-0.016 0.017 127.232-127.232c7.93-7.884 18.861-12.758 30.931-12.758s23 4.874 30.933 12.76l-0.002-0.002c7.884 7.93 12.758 18.861 12.758 30.931s-4.874 23-12.76 30.933l0.002-0.002-127.671 127.232c-7.837 7.562-18.504 12.236-30.263 12.284l-0.010 0z",
    AND: "M510.696 359.878c-0.453 0.016-0.986 0.025-1.521 0.025-11.941 0-22.841-4.459-31.125-11.802l0.049 0.043c-8.312-7.931-13.479-19.094-13.479-31.465 0-0.246 0.002-0.491 0.006-0.735l-0 0.037c-0.001-0.088-0.001-0.192-0.001-0.295 0-11.954 5.189-22.695 13.437-30.096l0.038-0.033c8.237-7.103 19.043-11.429 30.859-11.429s22.622 4.326 30.92 11.481l-0.061-0.052c8.312 7.931 13.479 19.094 13.479 31.465 0 0.246-0.002 0.491-0.006 0.735l0-0.037c0.059 0.803 0.093 1.74 0.093 2.685 0 11.551-5.063 21.919-13.091 29.007l-0.042 0.036c-7.55 6.495-17.448 10.45-28.27 10.45-0.452 0-0.902-0.007-1.351-0.021l0.066 0.002zM554.16 450.716v255.565c0.073 1.094 0.115 2.371 0.115 3.657 0 13.793-4.794 26.465-12.808 36.443l0.088-0.114c-7.931 8.312-19.094 13.479-31.465 13.479-0.246 0-0.491-0.002-0.735-0.006l0.037 0c-0.416 0.016-0.904 0.024-1.395 0.024-12.107 0-22.957-5.381-30.29-13.881l-0.044-0.052c-7.66-9.817-12.282-22.33-12.282-35.923 0-1.277 0.041-2.544 0.121-3.8l-0.009 0.171v-252.958c-0.068-1.046-0.106-2.269-0.106-3.5 0-13.492 4.622-25.904 12.37-35.74l-0.094 0.123c7.288-8.306 17.924-13.522 29.779-13.522 0.686 0 1.367 0.017 2.044 0.052l-0.095-0.004c0.208-0.004 0.453-0.006 0.698-0.006 12.37 0 23.533 5.168 31.449 13.462l0.016 0.017c8.122 9.036 13.090 21.050 13.090 34.225 0 0.803-0.018 1.603-0.055 2.397l0.004-0.113zM510.696 1024c-282.208-0.742-510.696-229.687-510.696-511.998 0-282.77 229.23-512 512-512 282.616 0 511.751 228.981 512 511.539l0 0.025c0 0.129 0 0.282 0 0.435 0 282.77-229.23 512-512 512-0.153 0-0.305-0-0.458-0l0.023 0zM512 87.362c-0.142-0-0.31-0-0.479-0-234.761 0-425.073 190.312-425.073 425.073s190.312 425.073 425.073 425.073c234.761 0 425.073-190.312 425.073-425.073 0-117.478-47.657-223.825-124.692-300.763l-0.004-0.004c-76.793-76.696-182.789-124.17-299.872-124.306l-0.026-0z",
    QUESTION: "M347.708 404.645c0.464-23.289 7.876-44.758 20.238-62.524l-0.245 0.372c14.142-22.266 33.564-40.016 56.557-51.778l0.815-0.379c24.241-13.157 53.078-20.891 83.721-20.891 1.127 0 2.252 0.010 3.374 0.031l-0.168-0.002c1.496-0.044 3.256-0.069 5.022-0.069 28.329 0 55.154 6.438 79.092 17.93l-1.099-0.475c23.52 10.183 42.849 26.298 56.648 46.492l0.289 0.448c12.251 17.978 19.561 40.176 19.561 64.080 0 0.239-0.001 0.478-0.002 0.717l0-0.037c0.014 0.64 0.022 1.395 0.022 2.151 0 16.803-4.023 32.666-11.159 46.678l0.27-0.585c-7.415 13.647-16.232 25.374-26.511 35.638l-0.002 0.002c-10.431 9.997-28.686 26.947-55.199 50.418-6.085 5.65-12.17 11.735-17.82 17.82-3.692 4.021-6.878 8.595-9.402 13.562l-0.16 0.346c-2.004 3.596-3.778 7.774-5.098 12.149l-0.118 0.455c-0.784 8.171-2.63 15.686-5.411 22.729l0.196-0.562c-1.35 18.815-16.946 33.568-35.987 33.568-0.948 0-1.888-0.037-2.818-0.108l0.123 0.008c-0.503 0.024-1.093 0.038-1.686 0.038-10.356 0-19.74-4.163-26.569-10.907l0.004 0.004c-7.081-7.707-11.421-18.029-11.421-29.366 0-1.137 0.044-2.265 0.129-3.38l-0.009 0.148c-0.039-1.117-0.061-2.431-0.061-3.749 0-30.264 11.585-57.822 30.561-78.481l-0.076 0.084c9.562-9.997 22.166-21.732 37.813-35.64s23.47-21.297 29.555-27.382c6.303-5.721 11.537-12.481 15.46-20.032l0.187-0.396c4.1-7.020 6.521-15.454 6.521-24.454 0-0.113-0-0.225-0.001-0.338l0 0.017c0.001-0.094 0.001-0.205 0.001-0.316 0-17.17-7.543-32.579-19.496-43.093l-0.064-0.055c-12.214-11.098-28.513-17.892-46.398-17.892-1.108 0-2.21 0.026-3.305 0.078l0.155-0.006c-1.581-0.127-3.423-0.2-5.282-0.2-18.059 0-34.521 6.841-46.934 18.073l0.060-0.053c-12.133 14.896-21.419 32.637-26.715 52.026l-0.233 1c-3.467 20.829-21.354 36.513-42.904 36.513-0.197 0-0.393-0.001-0.589-0.004l0.030 0c-11.873-0.052-22.614-4.856-30.427-12.607l0.003 0.003c-7.624-6.954-12.537-16.766-13.036-27.73l-0.003-0.087zM505.48 759.307c-0.148 0.002-0.323 0.002-0.499 0.002-13.042 0-24.928-4.952-33.879-13.079l0.042 0.037c-9.137-8.009-14.875-19.703-14.875-32.738 0-1.021 0.035-2.034 0.105-3.038l-0.008 0.136c-0.030-0.605-0.047-1.315-0.047-2.028 0-12.807 5.539-24.32 14.352-32.274l0.038-0.034c8.837-8.605 20.923-13.911 34.248-13.911 0.184 0 0.367 0.001 0.551 0.003l-0.028-0c0.397-0.012 0.863-0.019 1.331-0.019 12.936 0 24.628 5.332 32.996 13.918l0.010 0.010c8.637 9.096 13.95 21.422 13.95 34.988s-5.313 25.892-13.971 35.010l0.021-0.022c-8.667 8.083-20.336 13.045-33.164 13.045-0.259 0-0.518-0.002-0.777-0.006l0.039 0zM512 1024c-282.77 0-512-229.23-512-512s229.23-512 512-512c282.617 0 511.752 228.982 512 511.541l0 0.024c0 282.857-229.177 512.187-511.976 512.435l-0.024 0zM512 87.362c-0.013-0-0.028-0-0.044-0-234.761 0-425.073 190.312-425.073 425.073s190.312 425.073 425.073 425.073c234.761 0 425.073-190.312 425.073-425.073 0-117.262-47.482-223.434-124.267-300.338l0.005 0.005c-76.937-77.056-183.284-124.728-300.765-124.74l-0.003-0z"
};

;// CONCATENATED MODULE: ./src/components/Icon/Icon.tsx



const Icon = (param)=>{
    let { onClick , icon , width ="16" , height , color ="icon-orange" , className =""  } = param;
    const getColor = ()=>{
        switch(color){
            case "icon-orange":
                return "#fdb933";
            case "dark-grey":
                return "#2a3030";
            default:
                return color;
        }
    };
    const styles = {
        svg: {
            display: "inline-block",
            verticalAlign: "middle"
        },
        path: {
            fill: getColor()
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        onClick: onClick,
        style: styles.svg,
        width: width,
        height: height ? height : width,
        viewBox: "".concat(icon === "RIGHT_ARROW" ? "0 0 2000 1024" : "0 0 1600 1024"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            style: styles.path,
            d: ICONS[icon]
        })
    });
};
/* harmony default export */ var Icon_Icon = (Icon);

;// CONCATENATED MODULE: ./src/components/Icon/index.ts



/***/ }),

/***/ 17856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Picture; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Picture/Picture.tsx


const PictureProvider = (param)=>{
    let { data , className , width , height , style  } = param;
    const fullUrl = "https://www-api.coderslab.at/" + data.publicUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: fullUrl,
        alt: data.description,
        title: data.name,
        className: className,
        loading: "lazy",
        style: style,
        width: width,
        height: height
    });
};
/* harmony default export */ var Picture = (PictureProvider);

;// CONCATENATED MODULE: ./src/components/Picture/index.ts



/***/ }),

/***/ 73876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useTopBarState; },
/* harmony export */   "Z": function() { return /* binding */ TopBarStateProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const initialTopBarContextState = {
    visibleState: true,
    update: ()=>null
};
const TopBarContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initialTopBarContextState);
const useTopBarState = ()=>(0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(TopBarContext);
const TopBarStateProvider = (param)=>{
    let { children  } = param;
    const [topBarVisibleState, setTopBarVisibleState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialTopBarContextState.visibleState);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TopBarContext.Provider, {
        value: {
            visibleState: topBarVisibleState,
            update: setTopBarVisibleState
        },
        children: children
    });
};


/***/ }),

/***/ 62084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(48680);
;// CONCATENATED MODULE: ./src/blocks/MainHeader/assets/icons.tsx


const contactIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.995",
    height: "13.95",
    viewBox: "0 0 15.995 13.95",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        transform: "translate(-392.063 -305.924)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                transform: "translate(395.369 310.442)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M397.557,314.174a1.17,1.17,0,1,1,1.17-1.17A1.171,1.171,0,0,1,397.557,314.174Zm0-1.538a.367.367,0,1,0,.367.368A.368.368,0,0,0,397.557,312.636Z",
                        transform: "translate(-396.387 -311.833)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M402.163,314.174a1.17,1.17,0,1,1,1.17-1.17A1.172,1.172,0,0,1,402.163,314.174Zm0-1.538a.367.367,0,1,0,.367.368A.368.368,0,0,0,402.163,312.636Z",
                        transform: "translate(-397.471 -311.833)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M406.768,314.174a1.17,1.17,0,1,1,1.17-1.17A1.171,1.171,0,0,1,406.768,314.174Zm0-1.538a.367.367,0,1,0,.368.368A.367.367,0,0,0,406.768,312.636Z",
                        transform: "translate(-398.555 -311.833)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M403.515,319.874a.4.4,0,0,1-.317-.154l-2.11-2.713h-4.566a4.463,4.463,0,0,1-4.459-4.456V310.38a4.462,4.462,0,0,1,4.459-4.456h7.08a4.461,4.461,0,0,1,4.456,4.456v2.171A4.461,4.461,0,0,1,403.916,317v2.478a.4.4,0,0,1-.4.4Zm-6.993-13.147a3.659,3.659,0,0,0-3.656,3.653v2.171a3.659,3.659,0,0,0,3.656,3.653h4.763a.4.4,0,0,1,.317.154l1.512,1.945v-1.7a.4.4,0,0,1,.4-.4h.087a3.657,3.657,0,0,0,3.653-3.653V310.38a3.657,3.657,0,0,0-3.653-3.653Z"
            })
        ]
    })
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/validators.ts
var validators = __webpack_require__(44624);
;// CONCATENATED MODULE: ./src/blocks/MainHeader/Components/DesktopMenuItem.tsx




const DesktopMenuItem = (param)=>{
    let { item , lang , containerScrollLeft  } = param;
    const ref = (0,react.useRef)(null);
    const styleForMenu = {};
    if (ref && ref.current) {
        if (containerScrollLeft !== undefined) {
            const left = ref.current.offsetLeft - containerScrollLeft;
            styleForMenu.left = "".concat(left, "px");
        } else {
            styleForMenu.left = "".concat(ref.current.offsetLeft, "px");
        }
    }
    const getSecondLevelMenuChildren = (menuItem)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "navigationSubMenu__secondLevelContainer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "navigationSubMenu__secondLevel",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: menuItem.children.map((lastLevelItem)=>{
                        const additionalText = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "navigationSubMenu__additionalTextLabel",
                            children: [
                                lastLevelItem.additionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "navigationSubMenu__additionalTextLabel",
                                    children: lastLevelItem.additionalText
                                }),
                                lastLevelItem.additionalTextWithBg && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: lastLevelItem.additionalTextWbgColor ? lastLevelItem.additionalTextWbgColor : undefined,
                                        padding: "1px 10px",
                                        backgroundColor: lastLevelItem.additionalTextWbgBackground ? lastLevelItem.additionalTextWbgBackground : undefined
                                    },
                                    children: lastLevelItem.additionalTextWithBg
                                })
                            ]
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: lastLevelItem.menuHeader ? "navigationSubMenu__secondLevelItem navigationSubMenu__secondLevelItem--bold" : "navigationSubMenu__secondLevelItem",
                            children: lastLevelItem.urls ? (0,validators/* isFullUrl */.AU)(lastLevelItem.urls) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: lastLevelItem.seoTitle ? lastLevelItem.seoTitle : undefined,
                                href: lastLevelItem.urls,
                                target: lastLevelItem.target,
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        lastLevelItem.names,
                                        additionalText
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                passHref: true,
                                href: "/".concat(lang).concat(lastLevelItem.urls),
                                title: lastLevelItem.seoTitle ? lastLevelItem.seoTitle : undefined,
                                target: lastLevelItem.target,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        lastLevelItem.names,
                                        additionalText
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                title: lastLevelItem.seoTitle ? lastLevelItem.seoTitle : undefined,
                                children: [
                                    lastLevelItem.names,
                                    lastLevelItem.additionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "navigationSubMenu__additionalTextLabel",
                                        children: lastLevelItem.additionalText
                                    })
                                ]
                            })
                        }, lastLevelItem.id);
                    })
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        ref: ref,
        children: [
            item.urls ? (0,validators/* isFullUrl */.AU)(item.urls) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                title: item.seoTitle ? item.seoTitle : undefined,
                href: item.urls,
                target: item.target,
                rel: "noopener noreferrer",
                children: item.names
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: "/".concat(lang).concat(item.urls),
                title: item.seoTitle ? item.seoTitle : undefined,
                target: item.target,
                children: item.names
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                title: item.seoTitle ? item.seoTitle : undefined,
                children: item.names
            }),
            !!item.children.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "navigationSubMenu",
                style: styleForMenu,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "navigationSubMenu__firstLevel",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: item.children.map((subMenuItem)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "navigationSubMenu__firstLevelItem",
                                children: [
                                    subMenuItem.urls ? (0,validators/* isFullUrl */.AU)(subMenuItem.urls) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: subMenuItem.urls,
                                        title: subMenuItem.seoTitle ? subMenuItem.seoTitle : undefined,
                                        target: subMenuItem.target,
                                        rel: "noopener noreferrer",
                                        className: subMenuItem.menuHeader ? "navigationSubMenu__firstLevel--bold" : "",
                                        children: subMenuItem.names
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/".concat(lang).concat(subMenuItem.urls),
                                        title: subMenuItem.seoTitle ? subMenuItem.seoTitle : undefined,
                                        className: subMenuItem.menuHeader ? "navigationSubMenu__firstLevel--bold" : "",
                                        target: subMenuItem.target,
                                        children: subMenuItem.names
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        title: subMenuItem.seoTitle ? subMenuItem.seoTitle : undefined,
                                        className: subMenuItem.menuHeader ? "navigationSubMenu__firstLevel--bold" : "",
                                        children: subMenuItem.names
                                    }),
                                    getSecondLevelMenuChildren(subMenuItem)
                                ]
                            }, subMenuItem.id))
                    })
                })
            })
        ]
    }, item.id);
};
/* harmony default export */ var Components_DesktopMenuItem = (DesktopMenuItem);

// EXTERNAL MODULE: ./src/blocks/MainHeader/utils/LogoProvider.ts
var LogoProvider = __webpack_require__(49611);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(30674);
// EXTERNAL MODULE: ./utils/icons.tsx
var icons = __webpack_require__(42108);
;// CONCATENATED MODULE: ./src/blocks/MainHeader/Components/DesktopMenu.tsx
/* provided dependency */ var process = __webpack_require__(83454);







const DesktopMenu = (param)=>{
    let { menuItems , lang , handleLanguageSwitch  } = param;
    const ref = (0,react.useRef)(null);
    const [showLeftArrow, setShowLeftArrow] = (0,react.useState)(false);
    const [showRightArrow, setShowRightArrow] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)();
    (0,react.useEffect)(()=>{
        {
            setShowLeftArrow(shouldLeftArrowShow());
            setShowRightArrow(shouldRightArrowShow());
        }
    });
    const sideScroll = (direction)=>{
        const { current  } = ref;
        if (current) {
            let scrollAmount = 0;
            const step = 10;
            const distance = 100;
            const speed = 25;
            const slideTimer = setInterval(()=>{
                if (direction == "left") {
                    current.scrollLeft -= step;
                } else {
                    current.scrollLeft += step;
                }
                scrollAmount += step;
                if (scrollAmount >= distance) {
                    window.clearInterval(slideTimer);
                }
                setShowLeftArrow(shouldLeftArrowShow());
                setShowRightArrow(shouldRightArrowShow());
            }, speed);
        }
    };
    const shouldLeftArrowShow = ()=>{
        const { current  } = ref;
        return current ? current.scrollLeft !== 0 && current.scrollWidth > current.clientWidth : true;
    };
    const shouldRightArrowShow = ()=>{
        const { current  } = ref;
        return current ? current.scrollWidth > current.clientWidth && current.scrollLeft + current.clientWidth !== current.scrollWidth : true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "main-header__container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-header__logoSection",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "/".concat(lang),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "mainLogo",
                        src: (0,LogoProvider/* getLogoSrcForCurrentLang */.j)(lang),
                        alt: "CodersLab"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-header__navigationContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: "main-header__navigation",
                    children: [
                        showLeftArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "main-header__navigation--leftArrow",
                            onClick: ()=>sideScroll("left"),
                            children: icons/* chevronRight */.EI
                        }),
                        showRightArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "main-header__navigation--rightArrow",
                            onClick: ()=>sideScroll("right"),
                            children: icons/* chevronRight */.EI
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "navigationMenu",
                            ref: ref,
                            children: menuItems.map((item)=>{
                                var _ref_current;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Components_DesktopMenuItem, {
                                    item: item,
                                    lang: lang,
                                    containerScrollLeft: ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.scrollLeft
                                }, item.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "main-header__right-section",
                children: [
                     true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "main-header__languages",
                        onClick: handleLanguageSwitch,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: lang === "at" ? "main-header__languages--active" : "",
                                    children: "at"
                                }),
                                "\xa0/\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: lang === "en" ? "main-header__languages--active" : "",
                                    children: "en"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/".concat(lang).concat(t("routes-contact")),
                        className: "modern-button modern-button-primary modern-button-small contact-button",
                        children: [
                            contactIcon,
                            " ",
                            t("headers-contact")
                        ]
                    }),
                    process.env.NEXT_PUBLIC_SHOP_URL_BASE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "modern-button modern-button-primary modern-button-small shop-button",
                        href: process.env.NEXT_PUBLIC_SHOP_URL_BASE,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            icons/* cartIcon */.ul,
                            " ",
                            t("header-shop")
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Components_DesktopMenu = (DesktopMenu);

// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./node_modules/rc-drawer/es/index.js + 7 modules
var es = __webpack_require__(90991);
// EXTERNAL MODULE: ./node_modules/rc-drawer/assets/index.css
var assets = __webpack_require__(12322);
// EXTERNAL MODULE: ./src/components/Icon/index.ts + 2 modules
var Icon = __webpack_require__(68257);
// EXTERNAL MODULE: ./src/components/Picture/index.ts + 1 modules
var Picture = __webpack_require__(17856);
;// CONCATENATED MODULE: ./src/blocks/MainHeader/Components/MobileMenu.tsx
/* provided dependency */ var MobileMenu_process = __webpack_require__(83454);










const MobileMenu = (param)=>{
    let { lang , mobileBarItems , menuItems , handleLanguageSwitch  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [openDrawer, setOpenDrawer] = (0,react.useState)(false);
    const [secondLevelChildId, setSecondLevelChildId] = (0,react.useState)("");
    const handleOpenDrawer = ()=>setOpenDrawer(true);
    const handleCloseDrawer = ()=>{
        setOpenDrawer(false);
        setSecondLevelChildId("");
    };
    const handleOpenSecondLevel = (childId)=>setSecondLevelChildId(childId);
    const handleCloseSecondLevel = ()=>setSecondLevelChildId("");
    const renderItem = (names, url, target, id, children, seoTitle, onClickHandler)=>{
        return children.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            title: seoTitle ? seoTitle : undefined,
            className: "mobileMenu__item mobileMenu__firstLevelSubItem",
            onClick: ()=>onClickHandler(id),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: names
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        color: "dark-grey",
                        icon: "NEXT",
                        width: "16px",
                        height: "16px"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mobileMenu__item mobileMenu__firstLevelSubItem",
            children: url ? (0,validators/* isFullUrl */.AU)(url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: url,
                title: seoTitle ? seoTitle : undefined,
                target: target,
                rel: "noopener noreferrer",
                children: names
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/".concat(lang).concat(url),
                title: seoTitle ? seoTitle : undefined,
                target: target,
                children: names
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                title: seoTitle ? seoTitle : undefined,
                children: names
            })
        });
    };
    const renderFirstLevelItem = (name, url, target, seoTitle)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mobileMenu__item",
            children: url ? (0,validators/* isFullUrl */.AU)(url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: url,
                title: seoTitle ? seoTitle : undefined,
                target: target,
                rel: "noopener noreferrer",
                children: name
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/".concat(lang).concat(url),
                title: seoTitle ? seoTitle : undefined,
                target: target,
                children: name
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                title: seoTitle ? seoTitle : undefined,
                children: name
            })
        });
    };
    const renderSecondLevel = (item)=>{
        const showWithIcon = item.children.find((i)=>i.iconPicture && i.iconPicture.publicUrl);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "mobileMenu__secondLevel",
            children: item.children.map((lastLevelItem)=>{
                const linkContetnt = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        showWithIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "navigationSubMenu__secondLevelItemImg",
                            children: lastLevelItem.iconPicture && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                data: lastLevelItem.iconPicture
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: showWithIcon ? "navigationSubMenu__secondLevelItemWithImg" : "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        " ",
                                        lastLevelItem.names
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "navigationSubMenu__additionalTextLabel",
                                    children: [
                                        lastLevelItem.additionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "navigationSubMenu__additionalTextLabel",
                                            children: lastLevelItem.additionalText
                                        }),
                                        lastLevelItem.additionalTextWithBg && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                color: lastLevelItem.additionalTextWbgColor ? lastLevelItem.additionalTextWbgColor : undefined,
                                                padding: "1px 10px",
                                                backgroundColor: lastLevelItem.additionalTextWbgBackground ? lastLevelItem.additionalTextWbgBackground : undefined
                                            },
                                            children: lastLevelItem.additionalTextWithBg
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: lastLevelItem.menuHeader ? "navigationSubMenu__secondLevelItem navigationSubMenu__secondLevelItem--bold navigationSubMenu__secondLevelItem--mobile" : "navigationSubMenu__secondLevelItem",
                    children: lastLevelItem.urls ? (0,validators/* isFullUrl */.AU)(lastLevelItem.urls) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: lastLevelItem.seoTitle ? lastLevelItem.seoTitle : undefined,
                        href: lastLevelItem.urls,
                        target: lastLevelItem.target,
                        rel: "noopener noreferrer",
                        children: linkContetnt
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: lastLevelItem.seoTitle ? lastLevelItem.seoTitle : undefined,
                        href: "/".concat(lang).concat(lastLevelItem.urls),
                        target: lastLevelItem.target,
                        children: linkContetnt
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        title: lastLevelItem.seoTitle ? lastLevelItem.seoTitle : undefined,
                        children: [
                            showWithIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "navigationSubMenu__secondLevelItemImg",
                                children: lastLevelItem.iconPicture && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                    data: lastLevelItem.iconPicture
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: showWithIcon ? "navigationSubMenu__secondLevelItemWithImg" : "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            " ",
                                            lastLevelItem.names
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "navigationSubMenu__additionalTextLabel",
                                        children: [
                                            lastLevelItem.additionalText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "navigationSubMenu__additionalTextLabel",
                                                children: lastLevelItem.additionalText
                                            }),
                                            lastLevelItem.additionalTextWithBg && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: lastLevelItem.additionalTextWbgColor ? lastLevelItem.additionalTextWbgColor : undefined,
                                                    padding: "1px 10px",
                                                    backgroundColor: lastLevelItem.additionalTextWbgBackground ? lastLevelItem.additionalTextWbgBackground : undefined
                                                },
                                                children: lastLevelItem.additionalTextWithBg
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, lastLevelItem.id);
            })
        });
    };
    const logoSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mobileMenu__headerSection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,LogoProvider/* getDarkLogoSrcForCurrentLang */.f)(lang),
                alt: "CodersLab"
            }),
            openDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "closeMenuButton",
                onClick: handleCloseDrawer,
                children: "+"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n          @media only screen and (max-width: 767px) {\n            iframe#usercom-launcher-dot-frame[name],\n            #usercom-greeting-wrapper-frame {\n              left: calc(100% / ".concat((mobileBarItems.length + 2) * 2, " - 20px) !important;\n            }\n          }\n\n          @media only screen and (min-width: 551px) and (max-width: 767px) {\n            #usercom-board-frame {\n              left: calc(100% / ").concat((mobileBarItems.length + 2) * 2, " - 20px) !important;\n            }\n          }\n         ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                width: "100vw",
                handler: false,
                className: "mainDrawer",
                open: openDrawer,
                onClose: handleCloseDrawer,
                placement: "left",
                level: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobileMenu",
                    children: [
                        logoSection,
                        menuItems.map((menuItem)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mobileMenu__firstLevel",
                                children: [
                                    renderFirstLevelItem(menuItem.names, menuItem.urls, menuItem.target, menuItem.seoTitle),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: menuItem.children.length ? "mobileMenu__itemsGroup" : "",
                                        children: menuItem.children.map((childItem)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    renderItem(childItem.names, childItem.urls, childItem.target, childItem.id, childItem.children, childItem.seoTitle, handleOpenSecondLevel),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* default */.Z, {
                                                        width: "100vw",
                                                        handler: false,
                                                        open: secondLevelChildId === childItem.id,
                                                        onClose: handleCloseSecondLevel,
                                                        level: [
                                                            ".drawer1",
                                                            ".drawer2"
                                                        ],
                                                        placement: "left",
                                                        children: [
                                                            logoSection,
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mobileMenu__itemHeader",
                                                                onClick: handleCloseSecondLevel,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                        className: "rotateArrow",
                                                                        color: "dark-grey",
                                                                        icon: "NEXT",
                                                                        width: "16px",
                                                                        height: "16px"
                                                                    }),
                                                                    childItem.names
                                                                ]
                                                            }),
                                                            renderSecondLevel(childItem)
                                                        ]
                                                    })
                                                ]
                                            }, childItem.id))
                                    })
                                ]
                            }, menuItem.id)),
                         true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobileMenu__languages",
                            onClick: handleLanguageSwitch,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: lang === "at" ? "mobileMenu__languages--active" : "",
                                        children: "at"
                                    }),
                                    "\xa0/\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: lang === "en" ? "mobileMenu__languages--active" : "",
                                        children: "en"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bottomMobileMenu",
                children: [
                    MobileMenu_process.env.NEXT_PUBLIC_UE_KEY && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bottomMobileMenu__item"
                    }),
                    mobileBarItems.map((param)=>{
                        let { names , seoTitle ="" , urls , iconPicture  } = param;
                        return (0,validators/* isFullUrl */.AU)(urls) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bottomMobileMenu__item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: urls,
                                children: [
                                    iconPicture ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                        data: iconPicture,
                                        className: "bottomMobileMenu__icon--white"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "bottomMobileMenu__icon--white",
                                        src: "/blocks/MainHeader/coursesList.svg",
                                        alt: names
                                    }),
                                    names
                                ]
                            })
                        }, names) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bottomMobileMenu__item",
                            title: seoTitle ? seoTitle : undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: "/".concat(lang).concat(urls),
                                children: [
                                    iconPicture ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                        data: iconPicture,
                                        className: "bottomMobileMenu__icon--white"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "bottomMobileMenu__icon--white",
                                        src: "/blocks/MainHeader/coursesList.svg",
                                        alt: names
                                    }),
                                    names
                                ]
                            })
                        }, urls);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bottomMobileMenu__item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: handleOpenDrawer,
                            className: openDrawer ? "open-menu-button active" : "open-menu-button",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "bottomMobileMenu__icon--white",
                                    src: "/blocks/MainHeader/menu.svg",
                                    alt: "menu icon"
                                }),
                                t("Menu")
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Components_MobileMenu = (MobileMenu);

;// CONCATENATED MODULE: ./src/blocks/MainHeader/MainHeader.tsx







const styleForLiveChat =  false ? 0 : "";
class MainHeader extends react.Component {
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    render() {
        const { lang , routes  } = this.props;
        const { scrollBackToTop  } = this.state;
        const menuItems = routes.filter((route)=>route.positions.includes(constants/* default.MENU_POSITIONS.TOP */.Z.MENU_POSITIONS.TOP) && route.names);
        const mobileBarItems = routes.filter((route)=>route.positions.includes(constants/* default.MENU_POSITIONS.MOBILE_BAR */.Z.MENU_POSITIONS.MOBILE_BAR) && route.names);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    className: "main-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                            children: styleForLiveChat
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                            query: "(min-width: 768px)",
                            defaultMatches: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_DesktopMenu, {
                                menuItems: menuItems,
                                lang: lang,
                                handleLanguageSwitch: this.handleLanguageSwitch
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/blocks/MainHeader/back2top.svg",
                            alt: "Back to Top",
                            onClick: this.scrollTop,
                            className: "back-to-top ".concat(scrollBackToTop ? "back-to-top--visible" : "back-to-top--hidden")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                    query: "(max-width: 767px)",
                    defaultMatches: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_MobileMenu, {
                        menuItems: menuItems,
                        lang: lang,
                        handleLanguageSwitch: this.handleLanguageSwitch,
                        mobileBarItems: mobileBarItems
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            scrollBackToTop: false
        };
        this.handleScroll = ()=>{
            this.setState({
                scrollBackToTop: window.scrollY > 250
            });
        };
        this.scrollTop = ()=>{
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        };
        this.handleLanguageSwitch = ()=>{
            const { lang , handleLanguageChange  } = this.props;
            const langToChang = lang === "at" ? "en" : "at";
            handleLanguageChange(langToChang);
        };
    }
}
/* harmony default export */ var MainHeader_MainHeader = (MainHeader);

;// CONCATENATED MODULE: ./src/blocks/MainHeader/index.ts


// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/TopBar/TopBarContext.tsx
var TopBarContext = __webpack_require__(73876);
// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(97005);
;// CONCATENATED MODULE: ./src/components/TopBar/TopBar.tsx






const TopBarContainer = (param)=>{
    let { topBars  } = param;
    const { pathname  } = (0,router.useRouter)();
    const [topBarVisible, setTopBarVisible] = (0,react.useState)(true);
    const [topBarExcludedUrl, setTopBarExcludedUrl] = (0,react.useState)(false);
    const [hasError, setHasError] = (0,react.useState)(false);
    const [topBar, setTopBar] = (0,react.useState)();
    const { update  } = (0,TopBarContext/* useTopBarState */.H)();
    const getData = async ()=>{
        try {
            let [topBar] = topBars;
            if (topBar) {
                const excludedUrls = Object.values(topBar.excludedUrls);
                topBar = {
                    ...topBar,
                    excludedUrls
                };
                const excludedUrl = excludedUrls.find((url)=>url === pathname);
                if (excludedUrl) {
                    setTopBarVisible(false);
                    update(false);
                }
                setTopBar(topBar);
            }
        } catch (e) {
            setHasError(true);
        }
    };
    (0,react.useEffect)(()=>{
        getData();
    }, []);
    (0,react.useEffect)(()=>{
        if (topBar) {
            const excludedUrl = topBar.excludedUrls.find((url)=>url === pathname);
            setTopBarExcludedUrl(!!excludedUrl);
        }
    }, [
        pathname
    ]);
    const handleCloseTopBar = ()=>{
        setTopBarVisible(false);
        update(false);
    };
    const TopBarLink = topBar && /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        passHref: true,
        href: topBar.url,
        style: {
            color: topBar.textColor
        },
        className: "topBar-link",
        children: [
            topBar.message,
            " ",
            " >>"
        ]
    });
    return !hasError && topBar && topBarVisible && !topBarExcludedUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "topBarContainer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                pauseOnHover: true,
                speed: 50,
                gradient: false,
                className: "topBar",
                style: {
                    backgroundColor: topBar.backgroundColor,
                    color: topBar.textColor
                },
                children: TopBarLink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "topBar__closeButton",
                onClick: handleCloseTopBar,
                children: "✚"
            })
        ]
    }) : null;
};
/* harmony default export */ var TopBar = (TopBarContainer);

;// CONCATENATED MODULE: ./src/components/TopBar/index.ts


;// CONCATENATED MODULE: ./src/components/LinkRender/LinkRender.tsx



const LinkRender = (param)=>{
    let { item , className , lang  } = param;
    if (/(http(s?)):\/\//gi.test(item.urls)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: item.urls,
            target: "_blank",
            rel: "noopener noreferrer nofollow",
            className: className,
            children: item.names
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/".concat(lang).concat(item.urls),
            className: className,
            children: item.names
        });
    }
};
/* harmony default export */ var LinkRender_LinkRender = (LinkRender);

// EXTERNAL MODULE: ./node_modules/mobile-device-detect/dist/index.js
var mobile_device_detect_dist = __webpack_require__(85088);
;// CONCATENATED MODULE: ./src/components/Footer/Footer.tsx









const Footer = (param)=>{
    let { routes , lang , socialMedia  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const parsedRoutes = routes.filter((route)=>route.positions.includes(constants/* default.MENU_POSITIONS.BOTTOM */.Z.MENU_POSITIONS.BOTTOM) && route.names);
    const routesToSplit = parsedRoutes;
    const halfWayThough = Math.floor(routesToSplit.length / 2);
    const routesLeft = routesToSplit.slice(0, halfWayThough);
    const routesRight = routesToSplit.slice(halfWayThough, routesToSplit.length);
    const currentYear = new Date().getFullYear();
    var _process_env_NEXT_PUBLIC_INSTAGRAM_URL;
    const NEXT_PUBLIC_INSTAGRAM_URL = (_process_env_NEXT_PUBLIC_INSTAGRAM_URL = "") !== null && _process_env_NEXT_PUBLIC_INSTAGRAM_URL !== void 0 ? _process_env_NEXT_PUBLIC_INSTAGRAM_URL : null;
    var _process_env_NEXT_PUBLIC_LINKEDIN_URL;
    const NEXT_PUBLIC_LINKEDIN_URL = (_process_env_NEXT_PUBLIC_LINKEDIN_URL = "") !== null && _process_env_NEXT_PUBLIC_LINKEDIN_URL !== void 0 ? _process_env_NEXT_PUBLIC_LINKEDIN_URL : null;
    var _process_env_NEXT_PUBLIC_FACEBOOK_URL;
    const NEXT_PUBLIC_FACEBOOK_URL = (_process_env_NEXT_PUBLIC_FACEBOOK_URL = "") !== null && _process_env_NEXT_PUBLIC_FACEBOOK_URL !== void 0 ? _process_env_NEXT_PUBLIC_FACEBOOK_URL : null;
    var _process_env_NEXT_PUBLIC_TWITTER_URL;
    const NEXT_PUBLIC_TWITTER_URL = (_process_env_NEXT_PUBLIC_TWITTER_URL = "") !== null && _process_env_NEXT_PUBLIC_TWITTER_URL !== void 0 ? _process_env_NEXT_PUBLIC_TWITTER_URL : null;
    var _process_env_NEXT_PUBLIC_YOUTUBE_URL;
    const NEXT_PUBLIC_YOUTUBE_URL = (_process_env_NEXT_PUBLIC_YOUTUBE_URL = "") !== null && _process_env_NEXT_PUBLIC_YOUTUBE_URL !== void 0 ? _process_env_NEXT_PUBLIC_YOUTUBE_URL : null;
    const socialMediaArrayIsEmpty = socialMedia.length === 0;
    const renderSocialMediaIcons = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "iconsContainer",
            children: socialMediaArrayIsEmpty ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    NEXT_PUBLIC_INSTAGRAM_URL && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: NEXT_PUBLIC_INSTAGRAM_URL,
                        target: "_blank",
                        rel: "noopener noreferrer nofollow",
                        className: "icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            icon: "INSTAGRAM",
                            width: "32px",
                            color: "white-icon"
                        })
                    }),
                    NEXT_PUBLIC_LINKEDIN_URL && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: NEXT_PUBLIC_LINKEDIN_URL,
                        target: "_blank",
                        rel: "noopener noreferrer nofollow",
                        className: "icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            icon: "LINKEDIN",
                            width: "32px",
                            color: "white-icon"
                        })
                    }),
                    NEXT_PUBLIC_FACEBOOK_URL && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: NEXT_PUBLIC_FACEBOOK_URL,
                        rel: "noopener noreferrer nofollow",
                        target: "_blank",
                        className: "icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            icon: "FACEBOOK",
                            width: "32px",
                            color: "white-icon"
                        })
                    }),
                    NEXT_PUBLIC_TWITTER_URL && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: NEXT_PUBLIC_TWITTER_URL,
                        rel: "noopener noreferrer nofollow",
                        target: "_blank",
                        className: "icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            icon: "TWITTER",
                            width: "32px",
                            color: "white-icon"
                        })
                    }),
                    NEXT_PUBLIC_YOUTUBE_URL && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: NEXT_PUBLIC_YOUTUBE_URL,
                        target: "_blank",
                        rel: "noopener noreferrer nofollow",
                        className: "icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            icon: "YT",
                            width: "32px",
                            color: "white-icon"
                        })
                    })
                ]
            }) : socialMedia.map((sm)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: sm.link,
                    target: "_blank",
                    rel: "noopener noreferrer nofollow",
                    className: "icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "socialMediaIcon",
                        alt: "social media icon",
                        src: "https://www-api.coderslab.at/" + sm.icon.publicUrls
                    })
                }, sm.link))
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                query: "(min-width: 768px)",
                defaultMatches: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "topContainer",
                            children: parsedRoutes.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRender_LinkRender, {
                                    className: "topContainer__text",
                                    lang: lang,
                                    item: item
                                }, item.id))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bottomContainer",
                            children: [
                                renderSocialMediaIcons(),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "https://coderslab.pl",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "bottomContainer__text bottomContainer__text--first",
                                    children: [
                                        t("footer-copy"),
                                        currentYear
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    passHref: true,
                                    href: "/".concat(lang).concat(t("routes-rules")),
                                    className: "bottomContainer__text",
                                    children: t("footer-rules")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    passHref: true,
                                    href: "/".concat(lang).concat(t("routes-privacy")),
                                    className: "bottomContainer__text",
                                    children: t("footer-policy")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                query: "(max-width: 767px)",
                defaultMatches: mobile_device_detect_dist.isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "topContainer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "topContainer__column topContainer__column--left",
                                    children: [
                                        routesLeft.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRender_LinkRender, {
                                                className: "topContainer__text",
                                                lang: lang,
                                                item: item
                                            }, item.id)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            passHref: true,
                                            href: "/".concat(lang).concat(t("routes-privacy")),
                                            className: "topContainer__text",
                                            children: t("footer-policy")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "topContainer__column topContainer__column--right",
                                    children: [
                                        routesRight.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRender_LinkRender, {
                                                className: "topContainer__text",
                                                lang: lang,
                                                item: item
                                            }, item.id)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            passHref: true,
                                            href: "/".concat(lang).concat(t("routes-rules")),
                                            className: "topContainer__text",
                                            children: t("footer-rules")
                                        })
                                    ]
                                }),
                                renderSocialMediaIcons()
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bottomContainer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bottomContainer__text bottomContainer__text--first",
                                children: t("footer-copy")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);

// EXTERNAL MODULE: ./utils/HttpClient.ts
var HttpClient = __webpack_require__(4866);
// EXTERNAL MODULE: ./utils/helpers.ts
var helpers = __webpack_require__(99328);
;// CONCATENATED MODULE: ./utils/staticPaths.json
var staticPaths_namespaceObject = JSON.parse('[{"pl":"/nasz-zespol","en":"/our-team","al":"/ekipi-jone"},{"pl":"/dane-do-umowy","en":"/data-for-agreement"}]');
// EXTERNAL MODULE: ./utils/LanguagesEnum.ts
var LanguagesEnum = __webpack_require__(74364);
;// CONCATENATED MODULE: ./utils/StaticPathsTranslations.ts


const getStaticPathTranslation = (slug, currentLocale, nextLocale)=>{
    const staticPaths = staticPaths_namespaceObject;
    const pathObject = staticPaths.find((staticPath)=>staticPath[currentLocale] === slug);
    var _pathObject_nextLocale;
    return pathObject ? (_pathObject_nextLocale = pathObject[nextLocale]) !== null && _pathObject_nextLocale !== void 0 ? _pathObject_nextLocale : pathObject[LanguagesEnum/* LanguagesEnum.EN */.n.EN] : null;
};

// EXTERNAL MODULE: ./src/components/BasicButton/index.ts + 1 modules
var BasicButton = __webpack_require__(50505);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
;// CONCATENATED MODULE: ./src/components/CookiesConfirmation/CookiesConfirmation.tsx







const COOKIE_AGREEMENT_KEY = "cookiesAgreement";
const CookiesConfirmation = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { locale: lang  } = (0,router.useRouter)();
    const [cookiesAgreement, setCookiesAgreement] = (0,react.useState)("true");
    (0,react.useEffect)(()=>{
        const cookie = (0,lib.getCookie)(COOKIE_AGREEMENT_KEY);
        setCookiesAgreement(String(!!cookie));
    }, []);
    const handleAgreement = ()=>{
        (0,lib.setCookies)(COOKIE_AGREEMENT_KEY, "true", {
            path: "/",
            maxAge: 31536000
        });
        setCookiesAgreement("true");
    };
    return cookiesAgreement === "false" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cookiesConfirmation",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " cookiesConfirmation__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("cookies")
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(lang, "/").concat(t("routes-privacy")),
                            children: t("cookies-link")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicButton/* default */.Z, {
                    onClick: handleAgreement,
                    className: "cookiesConfirmation__btn",
                    children: t("cookies-confirm")
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var CookiesConfirmation_CookiesConfirmation = (CookiesConfirmation);

;// CONCATENATED MODULE: ./src/components/CookiesConfirmation/index.ts


;// CONCATENATED MODULE: ./src/components/layout.tsx











const Layout = (param)=>{
    let { children , routes , topBars , slugs , companyData , hostUrl  } = param;
    const { locale , query , push , asPath  } = (0,router.useRouter)();
    var _companyData_socialMedia;
    const socialMedia = (_companyData_socialMedia = companyData === null || companyData === void 0 ? void 0 : companyData.socialMedia) !== null && _companyData_socialMedia !== void 0 ? _companyData_socialMedia : [];
    const changeLanguage = async (lang)=>{
        const { slug: slugQuery = []  } = query;
        let newUrl = "/";
        const staticPath = getStaticPathTranslation(asPath, locale, lang);
        if (staticPath) {
            newUrl = staticPath;
        } else if (slugQuery.length > 0) {
            const url = "/".concat(slugQuery.join("/"));
            const slugsFlatArray = (0,helpers/* getSlugsFlatArray */.$)(slugs);
            const slugObject = slugsFlatArray.find((slug)=>slug.name === url);
            if (slugObject) {
                const slugsResponse = await (0,HttpClient/* getSlugsByLang */.I7)(lang);
                const slugsInSecondLanguage = (0,helpers/* sonataDataGetter */.L)(slugsResponse);
                const slugsInSecondLanguageFlatArray = (0,helpers/* getSlugsFlatArray */.$)(slugsInSecondLanguage);
                const slugInSecondLanguageObject = slugsInSecondLanguageFlatArray.find((slug)=>slug.id === slugObject.id);
                if (slugInSecondLanguageObject && slugInSecondLanguageObject.name) {
                    newUrl = slugInSecondLanguageObject.name;
                }
            }
        }
        push(newUrl, newUrl, {
            locale: lang
        });
    };
    const getStructuredData = ()=>{
        const { names , pictures: { publicUrl  } , email , phone , cityName , streets , numbers , zips , socialMedia  } = companyData;
        const fullPictureUrl = "https://www-api.coderslab.at/" + publicUrl;
        let data = {
            "@context": "https://schema.org",
            "@type": "Organization",
            logo: fullPictureUrl,
            name: names
        };
        if (socialMedia) {
            const socialMediaUrls = socialMedia.map((sm)=>sm.link);
            data = {
                ...data,
                sameAs: socialMediaUrls
            };
        }
        if (hostUrl) {
            data = {
                ...data,
                url: hostUrl
            };
        }
        if (email) {
            data = {
                ...data,
                email
            };
        }
        if (phone) {
            data = {
                ...data,
                telephone: phone
            };
        }
        if (cityName && streets && numbers && zips) {
            const address = {
                "@type": "PostalAddress",
                streetAddress: "".concat(streets, " ").concat(numbers),
                addressLocality: cityName,
                postalCode: zips
            };
            data = {
                ...data,
                address
            };
        }
        return {
            __html: JSON.stringify(data)
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBarContext/* TopBarStateProvider */.Z, {
            children: [
                companyData && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: getStructuredData()
                }, "product-jsonld"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar, {
                    topBars: topBars
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainHeader_MainHeader, {
                    lang: locale,
                    handleLanguageChange: changeLanguage,
                    routes: routes
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {
                    lang: locale,
                    routes: routes,
                    socialMedia: socialMedia
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesConfirmation_CookiesConfirmation, {})
            ]
        })
    });
};
/* harmony default export */ var layout = (Layout);


/***/ }),

/***/ 4866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I7": function() { return /* binding */ getSlugsByLang; },
/* harmony export */   "Oi": function() { return /* binding */ sendDataForm; },
/* harmony export */   "Wb": function() { return /* binding */ sendLead; },
/* harmony export */   "ZP": function() { return /* binding */ HttpClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);


class HttpClient {
    constructor(locale){
        var _this = this;
        this.getPageBlocks = (slug)=>this.api.get("/api/pages/blocks?url=".concat(slug));
        this.getPageMeta = (slug)=>this.api.get("/api/page/meta?url=".concat(slug));
        this.getMainPageBlocks = ()=>this.api.get("/api/main/page/1/blocks");
        this.getMainPageMeta = ()=>this.api.get("/api/main/page/1/meta");
        this.getActiveTopBars = ()=>this.api.get("/api/top_bars?active=true");
        this.getMenuItems = ()=>this.api.get("/api/menus");
        this.getSlugs = ()=>this.api.get("/api/page/0/slugs");
        this.getCities = ()=>this.api.get("/api/cities");
        this.getProducts = ()=>this.api.get("/api/products");
        this.getFinancingMethods = ()=>this.api.get("/api/financing_methods");
        this.getProductsCategories = ()=>this.api.get("/api/product categories");
        this.getArticle = (slug)=>this.api.get("/api/post/".concat(slug, "/details"));
        this.getRelatedArticles = (slug, params)=>this.api.get("/api/posts/".concat(slug, "/related"), {
                params
            });
        this.getCoursesForList = ()=>{
            const currentDate = moment__WEBPACK_IMPORTED_MODULE_1___default()().format("YYYY-MM-DD");
            return this.api.get("/api/courses?pagination=false&order[startAt]=asc&startAt[after]=".concat(currentDate));
        };
        this.getRoute = (route)=>this.api.get(route);
        this.getModes = ()=>this.api.get("/api/course_modes");
        this.getDifficultyLevels = ()=>this.api.get("/api/difficulty levels");
        this.getTeams = ()=>this.api.get("/api/team_departments");
        this.getContactCourse = ()=>this.api.get("/api/contact_courses");
        this.getContactDepartments = ()=>this.api.get("/api/contact_departments");
        this.getFaq = (id)=>this.api.get("/api/faq_sections/".concat(id));
        this.getPosts = (params)=>this.api.get("/api/posts", {
                params
            });
        this.getMentor = (id)=>this.api.get("/api/mentors/".concat(id));
        this.getProductPartner = (id)=>this.api.get("/api/product_partners/".concat(id));
        this.getGraduateProject = (id)=>this.api.get("/api/graduate_projects/".concat(id));
        this.getStudentStory = (id)=>this.api.get("/api/student_stories/".concat(id));
        this.getSiteScript = function() {
            let slug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "index";
            return _this.api.get("/api/page/".concat(slug, "/script"));
        };
        this.getCompanyData = ()=>this.api.get("/api/company_datas");
        this.api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
            baseURL: "https://www-api.coderslab.at/",
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": locale
            }
        });
    }
}

const getSlugsByLang = (lang)=>{
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat("https://www-api.coderslab.at/", "api/page/0/slugs"), {
        headers: {
            "Accept-Language": lang
        }
    });
};
const sendLead = (form)=>axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat("https://www-api.coderslab.at/", "api/lead"), form);
const sendDataForm = (data)=>axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat("https://www-api.coderslab.at/", "api/email_send/data"), data);


/***/ }),

/***/ 74364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ LanguagesEnum; }
/* harmony export */ });
var LanguagesEnum;
(function(LanguagesEnum) {
    LanguagesEnum["AL"] = "al";
    LanguagesEnum["AT"] = "at";
    LanguagesEnum["CZ"] = "cz";
    LanguagesEnum["EN"] = "en";
    LanguagesEnum["ID"] = "id";
    LanguagesEnum["PL"] = "pl";
    LanguagesEnum["RO"] = "ro";
    LanguagesEnum["RS"] = "rs";
    LanguagesEnum["SI"] = "si";
})(LanguagesEnum || (LanguagesEnum = {}));


/***/ }),

/***/ 48680:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    GREY_BACKGROUND: "grey",
    LANGUAGE: {
        PL: "pl",
        RO: "ro",
        AT: "at",
        ID: "id",
        ES: "es",
        CZ: "cz"
    },
    MENU_POSITIONS: {
        TOP: "top",
        BOTTOM: "bottom",
        MOBILE_BAR: "mobile_bar"
    },
    UNDERNEATH_LAYOUT: "miniature_underneath",
    RES_MOBILE: 568,
    WHITE_BACKGROUND: "white"
});


/***/ }),

/***/ 99328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getSlugsFlatArray; },
/* harmony export */   "L": function() { return /* binding */ sonataDataGetter; }
/* harmony export */ });
const sonataDataGetter = (response)=>{
    const { data  } = response;
    return data["hydra:member"];
};
const getSlugsFlatArray = (slugs)=>{
    let slugsArray = [];
    slugs.forEach((slug)=>{
        if (slug.childs.length > 0) {
            slugsArray = [
                ...slugsArray,
                ...slug.childs,
                {
                    id: slug.id,
                    name: slug.name
                }
            ];
        } else {
            slugsArray.push({
                id: slug.id,
                name: slug.name
            });
        }
    });
    return slugsArray;
};


/***/ }),

/***/ 42108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ chevronRight; },
/* harmony export */   "FC": function() { return /* binding */ arrowRight; },
/* harmony export */   "UF": function() { return /* binding */ closeIcon; },
/* harmony export */   "V8": function() { return /* binding */ arrowIcon; },
/* harmony export */   "e2": function() { return /* binding */ arrowLeft; },
/* harmony export */   "jZ": function() { return /* binding */ magnifierIcon; },
/* harmony export */   "pk": function() { return /* binding */ locationIcon; },
/* harmony export */   "qC": function() { return /* binding */ filtersIcon; },
/* harmony export */   "ul": function() { return /* binding */ cartIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const arrowIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "27.669",
    height: "13.402",
    viewBox: "0 0 27.669 13.402",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        transform: "translate(27.669 145.402) rotate(180)",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            transform: "translate(0 132)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "slider-control-arrow",
                d: "M27.352,137.936h0l-5.647-5.62a1.081,1.081,0,0,0-1.525,1.532l3.792,3.773H1.081a1.081,1.081,0,1,0,0,2.162H23.97l-3.792,3.773a1.081,1.081,0,0,0,1.525,1.532l5.647-5.62h0A1.082,1.082,0,0,0,27.352,137.936Z",
                transform: "translate(0 -132)"
            })
        })
    })
});
const chevronRight = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "7.343",
    height: "11.404",
    viewBox: "0 0 7.343 11.404",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        transform: "translate(299.973 -1.319) rotate(90)",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.932,299.961a.813.813,0,0,0,.587-1.351l-4.872-5.695a.813.813,0,0,0-1.237,0L1.533,298.61a.813.813,0,1,0,1.235,1.056l4.261-4.974,4.26,4.974a.813.813,0,0,0,.643.3Z",
            transform: "translate(0 0)"
        })
    })
});
const magnifierIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19.192",
    height: "19.192",
    viewBox: "0 0 19.192 19.192",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        transform: "translate(0 0)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.278,13.29A7.787,7.787,0,0,1,13.291,2.277a7.636,7.636,0,0,1,1.171,9.4.328.328,0,0,0,.045.39l3.973,3.973a1.815,1.815,0,0,1,.278,2.6l-.121.121a1.814,1.814,0,0,1-2.6-.278l-3.965-3.965a.332.332,0,0,0-.4-.054A7.636,7.636,0,0,1,2.278,13.29Zm9.575-1.438a5.754,5.754,0,1,0-8.138,0A5.76,5.76,0,0,0,11.853,11.852Z",
                transform: "translate(-0.001 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(4.973 3.117)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M120.134,54.614a.8.8,0,0,0,.74-1.117,5.065,5.065,0,0,0-6.632-2.688.8.8,0,1,0,.626,1.48,3.456,3.456,0,0,1,4.525,1.834A.8.8,0,0,0,120.134,54.614Z",
                    transform: "translate(-113.752 -50.409)"
                })
            })
        ]
    })
});
const closeIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "13",
    viewBox: "0 0 12 13",
    fill: "none",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.41 3.42462C11.9958 2.83883 11.9958 1.88909 11.41 1.3033C10.8242 0.717514 9.87446 0.717515 9.28867 1.3033L6.10669 4.48528L2.92471 1.3033C2.33892 0.717514 1.38918 0.717514 0.803389 1.3033C0.217602 1.88909 0.217603 2.83883 0.803389 3.42462L3.98537 6.6066L0.803389 9.78858C0.217602 10.3744 0.217602 11.3241 0.803389 11.9099C1.38918 12.4957 2.33892 12.4957 2.92471 11.9099L6.10669 8.72792L9.28867 11.9099C9.87446 12.4957 10.8242 12.4957 11.41 11.9099C11.9958 11.3241 11.9958 10.3744 11.41 9.78858L8.22801 6.6066L11.41 3.42462Z"
    })
});
const cartIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.942",
    height: "13.068",
    viewBox: "0 0 12.942 13.068",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M30.482,17.475a1.268,1.268,0,0,0-.972-.429h-9.3l-.094-.7a1.42,1.42,0,0,0-1.2-1.349h-.683a.383.383,0,0,0,0,.766h.683c.123,0,.383.26.439.684l1.1,8.219a1.546,1.546,0,0,0,.524.955,1.577,1.577,0,0,0,.734.366,1.408,1.408,0,1,0,2.491.028h2.006a1.393,1.393,0,0,0-.156.642,1.408,1.408,0,1,0,2.816,0,1.393,1.393,0,0,0-.156-.642h1a.383.383,0,1,0,0-.766H21.992a.823.823,0,0,1-.781-.684l-.08-.6H28.69a1.59,1.59,0,0,0,1.54-1.349l.55-4.118A1.271,1.271,0,0,0,30.482,17.475Zm-6.891,9.18a.643.643,0,1,1-.643-.642A.643.643,0,0,1,23.592,26.655Zm4.51,0a.642.642,0,1,1-.643-.642A.643.643,0,0,1,28.1,26.655Zm1.8-8.675a.515.515,0,0,1,.113.415l-.23,1.727h-2.6l.154-2.31H29.51A.515.515,0,0,1,29.907,17.979ZM24.469,23.2l-.154-2.31h2.052l-.154,2.31Zm-.2-3.076-.154-2.31h2.462l-.154,2.31Zm-.922-2.31.154,2.31H20.619l-.308-2.31Zm-2.622,3.076h2.827L23.7,23.2H21.029ZM28.69,23.2H26.98l.154-2.31h2.554l-.216,1.626A.823.823,0,0,1,28.69,23.2Z",
        transform: "translate(-17.85 -14.995)"
    })
});
const filtersIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25.381",
    height: "25.381",
    viewBox: "0 0 25.381 25.381",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        transform: "translate(0)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20.84,0H4.541A4.546,4.546,0,0,0,0,4.541v16.3a4.546,4.546,0,0,0,4.541,4.541h16.3a4.546,4.546,0,0,0,4.541-4.541V4.541A4.546,4.546,0,0,0,20.84,0Zm3.053,20.84a3.057,3.057,0,0,1-3.053,3.053H4.541A3.057,3.057,0,0,1,1.487,20.84V4.541A3.057,3.057,0,0,1,4.541,1.487h16.3a3.057,3.057,0,0,1,3.053,3.053Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M82.533,81.927H71.207a2.336,2.336,0,0,0-4.429,0H65.011a.744.744,0,0,0,0,1.487h1.768a2.336,2.336,0,0,0,4.429,0H82.533a.744.744,0,1,0,0-1.487ZM68.993,83.52a.849.849,0,1,1,.849-.849A.85.85,0,0,1,68.993,83.52Z",
                transform: "translate(-61.081 -76.352)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M82.533,210.46H80.765a2.336,2.336,0,0,0-4.429,0H65.011a.744.744,0,1,0,0,1.487H76.336a2.336,2.336,0,0,0,4.429,0h1.768a.744.744,0,1,0,0-1.487Zm-3.982,1.593a.849.849,0,1,1,.849-.849A.85.85,0,0,1,78.55,212.053Z",
                transform: "translate(-61.081 -198.513)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M82.533,338.993H74.393a2.336,2.336,0,0,0-4.429,0H65.011a.744.744,0,0,0,0,1.487h4.954a2.336,2.336,0,0,0,4.429,0h8.139a.744.744,0,0,0,0-1.487Zm-10.354,1.593a.849.849,0,1,1,.849-.849A.85.85,0,0,1,72.179,340.586Z",
                transform: "translate(-61.081 -320.674)"
            })
        ]
    })
});
const locationIcon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11.766",
    height: "15.012",
    viewBox: "0 0 11.766 15.012",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        transform: "translate(-5.811 -3.001)",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.918,6.166a5.774,5.774,0,0,0-4.568-3.133,6.562,6.562,0,0,0-1.31,0A5.776,5.776,0,0,0,6.471,6.166a6.239,6.239,0,0,0,.855,6.867L11.248,17.8a.577.577,0,0,0,.892,0l3.922-4.769a6.239,6.239,0,0,0,.855-6.867Zm-5.223,4.917A2.31,2.31,0,1,1,14,8.774,2.31,2.31,0,0,1,11.694,11.084Z"
        })
    })
});
const arrowRight = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "7.343",
    height: "11.404",
    viewBox: "0 0 7.343 11.404",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        transform: "translate(299.973 -1.319) rotate(90)",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.932,299.961a.813.813,0,0,0,.587-1.351l-4.872-5.695a.813.813,0,0,0-1.237,0L1.533,298.61a.813.813,0,1,0,1.235,1.056l4.261-4.974,4.26,4.974a.813.813,0,0,0,.643.3Z",
            transform: "translate(0 0)"
        })
    })
});
const arrowLeft = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "7.343",
    height: "11.404",
    viewBox: "0 0 7.343 11.404",
    transform: "rotate(180)",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        transform: "translate(299.973 -1.319) rotate(90)",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.932,299.961a.813.813,0,0,0,.587-1.351l-4.872-5.695a.813.813,0,0,0-1.237,0L1.533,298.61a.813.813,0,1,0,1.235,1.056l4.261-4.974,4.26,4.974a.813.813,0,0,0,.643.3Z",
            transform: "translate(0 0)"
        })
    })
});


/***/ }),

/***/ 44624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ isFullUrl; },
/* harmony export */   "Nn": function() { return /* binding */ isAnchor; },
/* harmony export */   "tH": function() { return /* binding */ phoneValidator; }
/* harmony export */ });
const isFullUrl = (url)=>url.startsWith("http://") || url.startsWith("https://") || url.startsWith("www.");
const isAnchor = (url)=>url.startsWith("#");
function phoneValidator(values, value) {
    const PHONE_NUMBER_MIN_LENGTH = 9;
    if (!value || value.length < PHONE_NUMBER_MIN_LENGTH) {
        return false;
    }
    const errorPatterns = [
        "123123123",
        "123456789"
    ];
    const hasRightChars = /^\+?([0-9]{2,3})?[- ]?([0-9]{2,3})\)?[- ]?([0-9]{2,3})\)?[- ]?([0-9]{3,})$/;
    if (!hasRightChars.test(value)) {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const pureNumber = [
        ...value
    ].filter((char)=>char !== "+" && char !== "-" && char !== " ");
    const sameNumbers = new Set(pureNumber);
    if (sameNumbers.size === 1 || errorPatterns.includes(pureNumber.join(""))) {
        return false;
    }
    return true;
}


/***/ })

}]);